<template>
  <div class="wrap-contianer">
    <div class="backdrop">
      <img src="../assets/imgs/bj@2x.png" alt="" />
    </div>
    <div class="content-wrap">
      <div
        class="left-process"
        ref="leftProcess"
        :class="[MaskGuidelinesNumber == 1 ? 'dark' : '']"
      >
        <img src="../assets/imgs/liucheng@2x.png" alt="" />
      </div>
      <!-- 左边 流程图 end -->
      <div class="right-form">
        <div class="form-whiteboard">
          <div class="right-form-title">
            提交您的基本信息，让设计师更了解您的需求

            <div class="clear-todo" v-if="showClearFrom" @click="resetForm">
              <img src="../assets/imgs/qc@2x.png" alt="" />
              清除已填信息
            </div>
          </div>
          <!-- 标题 end -->

          <el-form
            ref="essential"
            :model="essentialForm"
            :rules="rules"
            class="demo-ruleForm"
            label-width="90px"
            label-position="left"
            :inline="true"
          >
            <div class="screen-one" ref="essential_info">
              <div class="info-title">下单人信息</div>
              <!-- 信息输入 标题 end -->
              <el-form-item label="申请人:" prop="order_apply_name" class="form-label">
                <el-input
                  class="form-input"
                  placeholder="请输入您的姓名"
                  :disabled="isLocalcrm"
                  v-model="ruleForm.order_apply_name"
                ></el-input>
              </el-form-item>
              <!-- 姓名 end -->
              <el-form-item label="手机号:" prop="order_phone" class="form-label not">
                <el-input
                  class="form-input"
                  placeholder="请输入您的手机号码"
                  :disabled="isLocalcrm"
                  v-model="ruleForm.order_phone"
                ></el-input>
              </el-form-item>
              <!-- 手机号 end -->
              <el-form-item label="邮箱:" prop="order_email" class="form-label">
                <el-input
                  class="form-input"
                  placeholder="请输入联系的邮箱号"
                  v-model="ruleForm.order_email"
                ></el-input>
              </el-form-item>
              <!-- 邮箱 end -->
            </div>
          </el-form>

          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm"
            label-width="90px"
            label-position="left"
            :inline="true"
          >
            <div class="screen-one" ref="ruleForm_info">
              <div class="info-title">项目信息</div>
              <!-- 信息输入 标题 end -->

              <el-form-item
                label="项目业态:"
                required
                class="form-label custom-form-label right-margin"
              >
                <el-form-item prop="order_business">
                  <el-select
                    class="adjacent-select custom-select-mini"
                    v-model="ruleForm.order_business"
                    placeholder="请选择"
                    @change="changeBusinessClass"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.id"
                      v-for="(item, index) in businessClassification"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="order_child_business"
                  style="margin-right: 0px"
                  v-show="ruleForm.order_business"
                >
                  <el-select
                    class="adjacent-select"
                    v-model="ruleForm.order_child_business"
                    placeholder="请选择"
                    :disabled="businessSubclass.length == 0"
                    @change="changeBusinessSubclass"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.id"
                      v-for="(item, index) in businessSubclass"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  class="adjacent-select"
                  style="margin-right: 0px"
                  v-show="!ruleForm.order_business"
                >
                </el-form-item>
              </el-form-item>
              <!-- 业态 end -->
              <el-form-item label="项目来源:" class="form-label not" required>
                <el-form-item prop="type">
                  <el-select
                    class="adjacent-select custom-select-width-mini"
                    v-model="ruleForm.order_type"
                    placeholder="请选择"
                    :disabled="typeDisabled"
                    @change="changeProjectSource"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.id"
                      v-for="(item, index) in projectSourceList"
                      :key="index"
                    ></el-option>
                  </el-select>
                  <!-- <el-select
										class="adjacent-select custom-select-width-mini"
										v-model="ruleForm.type"
										placeholder="请选择"
										:disabled="typeDisabled"
										@change="changeProjectSource"
									>
										<el-option
											:label="item.name"
											:value="item.id"
											v-for="(item, index) in projectSourceList"
											:key="index"
										></el-option>
									</el-select> -->
                </el-form-item>
                <el-form-item prop="order_pro_name">
                  <el-select
                    class="adjacent-select custom-select-width-madd"
                    v-infinite-scroll="getProjectNameList"
                    :infinite-scroll-disabled="!infiniteProjectName ? 'disabled' : ''"
                    remote
                    :loading="infiniteProjectNameLoading"
                    :remote-method="getCrmPlaceOrder"
                    :infinite-scroll-immediate="false"
                    filterable
                    v-model="ruleForm.order_pro_name"
                    placeholder="请选择项目名称"
                    :disabled="isLocalcrm"
                    @change="changeProjectName"
                    v-if="ruleForm.type == 1"
                  >
                    <!--  -->
                    <el-option
                      :label="item.name"
                      :value="item.name"
                      v-for="(item, index) in crm_projectNameList"
                      :key="index"
                    ></el-option>
                  </el-select>
                  <!--  -->
                  <el-input
                    class="form-input adjacent-select custom-select-width-madd"
                    placeholder="请输入项目名称"
                    :disabled="isLocalcrm"
                    v-model="ruleForm.order_pro_name"
                    v-else
                  ></el-input>
                </el-form-item>
              </el-form-item>
              <!-- 项目名称 end -->
              <el-form-item label="设计面积:" prop="order_pro_area" class="form-label">
                <el-input
                  class="form-input"
                  placeholder="请输入设计面积"
                  type="number"
                  min="1"
                  v-model.number="ruleForm.order_pro_area"
                  @change="changeOrderProArea"
                >
                  <template slot="suffix">
                    <div class="suffix-input">㎡</div>
                  </template></el-input
                >
              </el-form-item>
              <!-- 设计面积 -->
              <el-form-item label="相关项目:" class="form-label not">
                <el-select
                  class="form-select"
                  v-model="ruleForm.order_bind_id"
                  clearable
                  placeholder="请选择相关项目"
                  @change="changeSelectedOrderBindId"
                >
                  <el-option
                    :label="item.order_pro_name"
                    :value="item.id"
                    v-for="(item, index) in assoItemsAndSpecPro.project"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- 相关项目 end -->
              <el-form-item label="指定产品:" class="form-label">
                <el-select
                  class="form-select"
                  v-model="ruleForm.order_assign_pro"
                  clearable
                  placeholder="请选择指定产品"
                >
                  <el-option
                    :label="item.name"
                    :value="item.id"
                    v-for="(item, index) in assoItemsAndSpecPro.product"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- 指定产品 end -->
              <el-form-item label="备注:" class="form-label not">
                <el-input
                  class="textarea-form"
                  type="textarea"
                  placeholder="请输入备注信息"
                  v-model="ruleForm.order_pro_remark"
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
          <div class="screen-page" v-if="showDemandTitle"></div>
          <!-- 分割线 end -->
          <div class="screen-two" ref="serveForm_info">
            <!-- 其他 -->
            <el-form
              ref="serveForm"
              :model="serveForm"
              label-width="120px"
              label-position="left"
              v-if="ruleForm.type == 2"
            >
              <div class="info-title" v-show="showDemandTitle">
                需求信息
                <div class="check-details" @click="closeOrOpenFixedCheckDetails(1)">
                  查看需求明细
                </div>
              </div>
              <!-- 信息输入 标题 end -->
              <el-form-item
                class="screen-two-form-lalbel"
                label="方案服务:"
                :required="!serveForm.outboundService.length"
                v-if="demandServiceList.fafw && demandServiceList.fafw.length > 0"
              >
                <el-checkbox
                  v-for="(item, index) in demandServiceList.fafw"
                  :key="index"
                  v-model="item.select"
                  :label="item.name"
                  :true-label="1"
                  :false-label="0"
                  class="form-checkbox"
                  @change="changeServiceSelect($event, item)"
                  min-width="250px"
                ></el-checkbox>
              </el-form-item>
              <el-form-item
                class="screen-two-form-lalbel"
                label="外出服务:"
                :required="!serveForm.solutionService.length"
                v-if="demandServiceList.wcfw && demandServiceList.wcfw.length > 0"
              >
                <el-checkbox
                  v-for="(item, index) in demandServiceList.wcfw"
                  :key="index"
                  v-model="item.select"
                  :label="item.name"
                  :true-label="1"
                  class="form-checkbox"
                  :false-label="0"
                  min-width="250px"
                  @change="changeServiceSelect($event, item)"
                ></el-checkbox>
              </el-form-item>
            </el-form>
            <!-- crm -->
            <el-form
              ref="serveForm"
              :model="serveForm"
              label-width="120px"
              label-position="left"
              v-if="ruleForm.type == 1"
            >
              <div class="info-title" v-show="showDemandTitle">
                需求信息
                <div class="check-details" @click="closeOrOpenFixedCheckDetails(1)">
                  查看需求明细
                </div>
              </div>
              <!-- 信息输入 标题 end -->
              <el-form-item
                class="screen-two-form-lalbel"
                label="方案服务:"
                :required="!serveForm.outboundService.length"
                v-if="demandServiceList.crm_fafw && demandServiceList.crm_fafw.length > 0"
              >
                <el-checkbox
                  v-for="(item, index) in demandServiceList.crm_fafw"
                  :key="index"
                  v-model="item.select"
                  :label="item.name"
                  :true-label="1"
                  :false-label="0"
                  class="form-checkbox"
                  min-width="250px"
                  @change="changeServiceSelect($event, item)"
                ></el-checkbox>
              </el-form-item>
              <el-form-item
                class="screen-two-form-lalbel"
                label="外出服务:"
                :required="!serveForm.solutionService.length"
                v-if="demandServiceList.crm_wcfw && demandServiceList.crm_wcfw.length > 0"
              >
                <el-checkbox
                  v-for="(item, index) in demandServiceList.crm_wcfw"
                  :key="index"
                  v-model="item.select"
                  :label="item.name"
                  :true-label="1"
                  class="form-checkbox"
                  :false-label="0"
                  min-width="250px"
                  @change="changeServiceSelect($event, item)"
                ></el-checkbox>
              </el-form-item>
            </el-form>

            <div style="margin: 10px 0px"></div>
            <el-divider v-if="showDemandToast"></el-divider>
            <div style="margin: 20px 0px"></div>
            <!-- 其他 -->
            <el-form
              ref="needForm"
              label-width="250px"
              label-position="right"
              v-if="ruleForm.type == 2"
            >
              <!-- v-show="serveForm_id.length > un_showNeedTodo.length" -->
              <div class="form-title-screen-two" v-show="showDemandToast">
                请选择需求数量:
              </div>
              <div class="form-screen-main">
                <el-form-item
                  v-if="serveForm_id.indexOf('3') != -1"
                  class="form-label"
                  :label="illuminationCalculation.child[0].name"
                  required
                >
                  <el-input
                    class="form-input"
                    type="number"
                    :maxlength="3"
                    :max="100"
                    :placeholder="`请输入${illuminationCalculation.child[0].name}数量`"
                    v-model="illuminationCalculation.child[0].dw_num"
                    @change="
                      enterAloneCase($event, {
                        keyName: 'illuminationCalculation',
                        value: illuminationCalculation,
                      })
                    "
                  >
                    <template slot="suffix">
                      <div class="suffix-input">
                        {{ illuminationCalculation.child[0].dw_name }}
                      </div>
                    </template>
                  </el-input>
                </el-form-item>
                <!-- 照度计算 end -->
                <el-form-item
                  class="form-label"
                  v-if="serveForm_id.indexOf('4') != -1"
                  :label="intelligentSolutions.name"
                  required
                >
                  <el-radio
                    class="radio-only"
                    v-for="(item, index) in intelligentSolutions.child"
                    :key="index"
                    v-model="intelligentSolutions.radioGroup"
                    @change="
                      chageRadioCase($event, {
                        keyName: 'intelligentSolutions',
                        value: intelligentSolutions,
                      })
                    "
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-form-item>
                <!-- 智能标准方案 end -->
                <el-form-item
                  class="form-label"
                  v-if="serveForm_id.indexOf('6') != -1"
                  :label="pptProductPlanType.name"
                  required
                >
                  <el-radio
                    class="radio-only"
                    v-for="(item, index) in pptProductPlanType.child"
                    :key="index"
                    v-model="pptProductPlanType.radioGroup"
                    @change="
                      chageRadioCase($event, {
                        keyName: 'pptProductPlanType',
                        value: pptProductPlanType,
                      })
                    "
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-form-item>
                <!-- 智能PPT方案制作类型 end -->
                <el-form-item
                  class="form-label"
                  v-if="serveForm_id.indexOf('7') != -1"
                  :label="renderings.name"
                  required
                >
                  <el-form-item>
                    <div class="checkbox-input-group">
                      <div
                        class="checkbox-input"
                        v-for="(item, index) in renderings.child"
                        :key="index"
                      >
                        <el-checkbox
                          v-model="item.select"
                          :label="item.name"
                          :true-label="1"
                          :false-label="0"
                          @change="
                            changeCheckBoxCase($event, {
                              keyName: 'renderings',
                              value: renderings,
                            })
                          "
                        >
                        </el-checkbox>
                        <el-form-item v-if="item.select">
                          <el-input
                            class="renderings-input"
                            placeholder="请输入"
                            type="number"
                            v-model="item.dw_num"
                            @change="
                              changeCheckBoxInput($event, {
                                keyName: 'renderings',
                                value: renderings,
                                index: index,
                              })
                            "
                            maxlength="6"
                            minlength="1"
                          >
                            <template slot="suffix">
                              <div class="suffix-input">{{ item.dw_name }}</div>
                            </template>
                          </el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </el-form-item>
                </el-form-item>
                <!-- 效果图 end -->
                <el-form-item
                  class="form-label"
                  v-if="serveForm_id.indexOf('9') != -1"
                  :label="designTraining.child[0].name"
                  required
                >
                  <el-input
                    class="form-input"
                    type="number"
                    v-model="designTraining.child[0].dw_num"
                    :placeholder="`请输入${designTraining.child[0].name}天数`"
                    @change="
                      enterAloneCase($event, {
                        keyName: 'designTraining',
                        value: designTraining,
                      })
                    "
                  >
                    <template slot="suffix">
                      <div class="suffix-input">
                        {{ designTraining.child[0].dw_name }}
                      </div>
                    </template>
                  </el-input>
                </el-form-item>
                <!-- 设计推广/设计培训 end -->
                <el-form-item
                  class="form-label"
                  v-if="serveForm_id.indexOf('8') != -1"
                  :label="programReport.name"
                  required
                >
                  <el-form-item>
                    <div class="checkbox-input-group">
                      <div
                        class="checkbox-input not-margin"
                        v-for="(item, index) in programReport.child"
                        :key="index"
                      >
                        <el-radio
                          :label="item.id"
                          v-model="programReport.radioGroup"
                          @change="
                            chageRadioCase($event, {
                              keyName: 'programReport',
                              value: programReport,
                            })
                          "
                          >{{ item.name }}</el-radio
                        >
                        <el-form-item>
                          <el-input
                            class="renderings-input"
                            v-model="item.dw_num"
                            v-if="programReport.radioGroup == item.id"
                            @change="
                              chageRadioInput($event, {
                                keyName: 'programReport',
                                value: programReport,
                                index: index,
                              })
                            "
                            type="number"
                            placeholder="请输入"
                          >
                            <template slot="suffix">
                              <div class="suffix-input">
                                {{ item.dw_name }}
                              </div>
                            </template>
                          </el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </el-form-item>
                </el-form-item>
                <!-- 方案汇报天数 end -->
                <el-form-item
                  v-if="serveForm_id.indexOf('10') != -1"
                  class="form-label"
                  :label="technicalSupport.name"
                  required
                >
                  <el-form-item>
                    <div class="checkbox-input-group">
                      <div
                        class="checkbox-input not-margin"
                        v-for="(item, index) in technicalSupport.child"
                        :key="index"
                      >
                        <el-radio
                          :label="item.id"
                          v-model="technicalSupport.radioGroup"
                          @change="
                            chageRadioCase($event, {
                              keyName: 'technicalSupport',
                              value: technicalSupport,
                            })
                          "
                          >{{ item.name }}</el-radio
                        >
                        <el-form-item>
                          <el-input
                            class="renderings-input"
                            placeholder="请输入"
                            type="number"
                            v-if="technicalSupport.radioGroup == item.id"
                            v-model="item.dw_num"
                            @change="
                              chageRadioInput($event, {
                                keyName: 'technicalSupport',
                                value: technicalSupport,
                                index: index,
                              })
                            "
                          >
                            <template slot="suffix">
                              <div class="suffix-input">{{ item.dw_name }}</div>
                            </template>
                          </el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </el-form-item>
                </el-form-item>
                <!-- 现场技术支持 end -->
                <el-form-item
                  v-if="
                    serveForm_id.indexOf('11') != -1 && afterSalesService.child.length
                  "
                  class="form-label"
                  :label="afterSalesService.child[0].name"
                  required
                >
                  <el-input
                    v-model="afterSalesService.child[0].dw_num"
                    class="form-input"
                    type="number"
                    placeholder="请输入智能售后服务天数"
                    @change="
                      enterAloneCase($event, {
                        keyName: 'afterSalesService',
                        value: afterSalesService,
                      })
                    "
                  >
                    <template slot="suffix">
                      <div class="suffix-input">
                        {{ afterSalesService.child[0].dw_name }}
                      </div>
                    </template>
                  </el-input>
                </el-form-item>
                <!-- 智能售后服务 end -->
                <el-form-item
                  v-if="serveForm_id.indexOf('12') != -1"
                  class="form-label peripherals"
                  :label="externalDeviceDocking.name"
                  required
                >
                  <el-form-item>
                    <el-form-item prop="deviceDockingType">
                      <div class="checkbox-input-group">
                        <div
                          class="checkbox-input"
                          v-for="(item, index) in externalDeviceDocking.child"
                          :key="index"
                        >
                          <el-checkbox
                            v-model="item.select"
                            @change="
                              changeCheckBoxCase($event, {
                                keyName: 'externalDeviceDocking',
                                value: externalDeviceDocking,
                              })
                            "
                            :label="item.id"
                            :true-label="1"
                            :false-label="0"
                          >
                            {{ item.name }}
                          </el-checkbox>
                          <el-form-item>
                            <el-input
                              class="renderings-input"
                              placeholder="请输入"
                              type="number"
                              v-if="item.select == 1"
                              v-model="item.dw_num"
                              @change="
                                changeCheckBoxInput($event, {
                                  keyName: 'externalDeviceDocking',
                                  value: externalDeviceDocking,
                                  index: index,
                                })
                              "
                              maxlength="6"
                              minlength="1"
                            >
                              <template slot="suffix">
                                <div class="suffix-input">
                                  {{ item.dw_name }}
                                </div>
                              </template>
                            </el-input>
                          </el-form-item>
                        </div>
                      </div>
                    </el-form-item>
                  </el-form-item>
                </el-form-item>
                <!-- 第三方设备对接类型 end -->
                <el-form-item
                  v-show="serveForm.outboundService.length > 0"
                  class="form-label"
                  label="外出时间:"
                  required
                >
                  <el-date-picker
                    class="date-picker-shelf"
                    v-model="order_dian_time"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm"
                    placeholder="请选择外出时间"
                    :picker-options="pickerOptions"
                    @change="changeDatePicker"
                  >
                  </el-date-picker>
                </el-form-item>
                <!-- 外出时间 end -->
                <el-form-item
                  v-show="serveForm.outboundService.length > 0"
                  class="form-label"
                  label="外出地址:"
                  required
                >
                  <el-input
                    class="form-input address"
                    type="textarea"
                    v-model="order_dian_address"
                    :autosize="{ minRows: 1, maxRows: 1 }"
                    placeholder="请输入外出地址"
                    resize="none"
                  ></el-input>
                </el-form-item>
                <!-- 外出地址 end -->
              </div>
            </el-form>

            <!-- crm -->
            <el-form
              ref="needForm"
              label-width="250px"
              label-position="right"
              v-if="ruleForm.type == 1"
            >
              <div class="form-title-screen-two" v-show="showDemandToast">
                请选择需求数量:
              </div>
              <div class="form-screen-main">
                <!-- <div v-if="demandServiceList.crm_fafw">
                  <div
                    v-for="(item, index) in demandServiceList.crm_fafw"
                    :key="index"
                  >
                    <el-form-item
                      v-if="serveForm_id.indexOf(String(item.id)) != -1"
                      class="form-label"
                      :label="item.child[0].name"
                      required
                    >
                      <el-input
                        class="form-input"
                        type="number"
                        :maxlength="3"
                        :max="100"
                        :placeholder="`请输入${item.child[0].name}数量`"
                        v-model="item.child[0].dw_num"
                        @change="
                          enterAloneCase($event, {
                            keyName: item.id,
                            value: item,
                          })
                        "
                      >
                        <template slot="suffix">
                          <div class="suffix-input">
                            {{ item.child[0].dw_name || "天" }}
                          </div>
                        </template>
                      </el-input>
                    </el-form-item>
                  </div>
                </div> -->
                <!-- crm智能标准方案 -->

                <el-form-item
                  class="form-label"
                  v-if="serveForm_id.indexOf('45') != -1"
                  :label="crmIntelligentSolutions.name"
                  required
                >
                  <el-radio
                    class="radio-only"
                    v-for="(item, index) in crmIntelligentSolutions.child"
                    :key="index"
                    v-model="crmIntelligentSolutions.radioGroup"
                    @change="
                      chageRadioCase($event, {
                        keyName: 'crmIntelligentSolutions',
                        value: crmIntelligentSolutions,
                      })
                    "
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-form-item>
                <!-- crm户外设计 -->
                <el-form-item
                  class="form-label"
                  v-if="serveForm_id.indexOf('47') != -1"
                  :label="crmOutdoor.name"
                  required
                >
                  <el-radio
                    class="radio-only"
                    v-for="(item, index) in crmOutdoor.child"
                    :key="index"
                    v-model="crmOutdoor.radioGroup"
                    @change="
                      chageRadioCase($event, {
                        keyName: 'crmOutdoor',
                        value: crmOutdoor,
                      })
                    "
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-form-item>

                <div v-if="demandServiceList.crm_wcfw">
                  <div v-for="(item, index) in demandServiceList.crm_wcfw" :key="index">
                    <el-form-item
                      v-if="serveForm_id.indexOf(String(item.id)) != -1"
                      class="form-label"
                      :label="item.child[0].name"
                      required
                    >
                      <el-input
                        class="form-input"
                        type="number"
                        :maxlength="3"
                        :max="100"
                        :placeholder="`请输入${item.child[0].name}数量`"
                        v-model="item.child[0].dw_num"
                        @change="
                          enterAloneCase($event, {
                            keyName: item.id,
                            value: item,
                          })
                        "
                      >
                        <template slot="suffix">
                          <div class="suffix-input">
                            {{ item.child[0].dw_name || "天" }}
                          </div>
                        </template>
                      </el-input>
                    </el-form-item>
                  </div>
                </div>
                <el-form-item
                  v-show="serveForm.outboundService.length > 0"
                  class="form-label"
                  label="外出时间:"
                  required
                >
                  <el-date-picker
                    class="date-picker-shelf"
                    v-model="order_dian_time"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm"
                    placeholder="请选择外出时间"
                    :picker-options="pickerOptions"
                    @change="changeDatePicker"
                  >
                  </el-date-picker>
                </el-form-item>
                <!-- 外出时间 end -->
                <el-form-item
                  v-show="serveForm.outboundService.length > 0"
                  class="form-label"
                  label="外出地址:"
                  required
                >
                  <el-input
                    class="form-input address"
                    type="textarea"
                    v-model="order_dian_address"
                    :autosize="{ minRows: 1, maxRows: 1 }"
                    placeholder="请输入外出地址"
                    resize="none"
                  ></el-input>
                </el-form-item>
                <!-- 外出地址 end -->
              </div>
            </el-form>
          </div>
          <div class="screen-page"></div>
          <div class="screen-three">
            <div class="content-order">
              <div class="content-order-left" ref="imgUpload">
                <div class="info-title">
                  图纸上传
                  <div
                    class="check-details pictrue"
                    @click="closeOrOpenFixedCheckDetails(2)"
                  >
                    示例图纸
                  </div>
                </div>
                <!-- 信息输入 标题 end -->
                <div class="todo-img">
                  支持jpg、jpeg、gif、png、bmp、pdf、tif、doc、docx、xls、xlsx、txt、rar、zip、skp、max、dwg、dxf、gz、ppt、pptx等格式
                </div>
                <div class="show-img-list">
                  <transition-group name="el-zoom-in-top">
                    <div
                      class="show-item-img"
                      v-for="(item, index) in fileList"
                      :key="index"
                    >
                      <div class="name-img">
                        {{ item.name }}
                        <div class="img-delete" @click="removeAppendix(index)">删除</div>
                      </div>
                      <div class="img-byte">{{ (item.size / 1024).toFixed(2) }}K</div>
                      <div class="img-loading" v-if="item.upping">
                        <div class="loading-width">
                          <el-progress
                            :stroke-width="8"
                            :percentage="item.progress"
                            :show-text="false"
                            status="success"
                          ></el-progress>
                        </div>
                        已上传 {{ item.progress }}%
                      </div>
                    </div>
                  </transition-group>
                </div>
                <div class="img-upload">
                  <el-upload
                    class="upload-demo"
                    :limit="20"
                    :multiple="true"
                    :file-list="fileList"
                    action=""
                    :show-file-list="false"
                    :before-upload="onBeforeUpload"
                    :auto-upload="false"
                    :on-change="handleChangeLoad"
                    style="display: flex; align-items: center"
                  >
                    <el-button size="small" plain type="danger"
                      ><img
                        class="download-icon"
                        src="../assets/imgs/shangchuan@2x.png"
                        alt=""
                      />
                      <img
                        class="download-icon-hover"
                        src="../assets/icon/sc-bai@2x.png"
                        alt=""
                      />
                      上传图纸</el-button
                    >
                  </el-upload>
                </div>
              </div>
              <div class="content-order-right" ref="priceSum">
                <div class="info-title" v-if="estimatedAmount.project_list">预估金额</div>
                <!-- 信息输入 标题 end -->
                <div class="table-order" v-if="estimatedAmount.project_list">
                  <el-table :data="estimatedAmount.project_list" style="width: 100%">
                    <el-table-column min-width="150" prop="name" label="需求项">
                      <template slot-scope="scopes">
                        {{ scopes.row.name }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="money_text"
                      label="小计"
                      min-width="100"
                      align="right"
                    >
                      <template slot-scope="scope">
                        <div class="price-scope">
                          <span>￥</span>{{ scope.row.money_text }}
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="order-right-total">
                    <div class="vip-discount">{{ estimatedAmount.level }}</div>
                    <div class="total-price">
                      <span>合计:</span> ￥{{ estimatedAmount.discount_total_money_text }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="submit-btn" ref="submitBtn">
              <el-button
                v-if="!crm_id || ruleForm.type == 2"
                class="submit-btn-save"
                type="warning"
                @click="saveForm"
                >保存草稿</el-button
              >
              <el-button
                v-if="serveForm_id.length > 0"
                type="danger"
                :disabled="onceChange"
                @click="submitForm('ruleForm')"
                class="submit-btn-place"
                >确认下单</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <!-- 右边 表单 end -->
    </div>
    <div class="fixed-change-details" v-if="showCheckDetails">
      <div class="fixed-change-details-content" v-if="showCheckDetailsType == 1">
        <div class="title">
          需求信息说明
          <img
            @click="closeOrOpenFixedCheckDetails"
            class="fixed-change-details-close"
            src="../assets/icon/guanbi@2x.png"
            alt=""
          />
        </div>
        <div class="fixed-change-details-table">
          <el-table :data="selecedCheckDetails" style="width: 100%" height="340">
            <el-table-column prop="name" label="需求内容" width="200"> </el-table-column>
            <el-table-column prop="deliverables" label="交付资料">
              <template slot-scope="scope">
                <div v-for="(item, index) in scope.row.deliverables" :key="index">
                  {{ index + 1 }}、{{ item }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="present_information" label="需提供的资料">
              <template slot-scope="scope">
                <div v-for="(item, index) in scope.row.present_information" :key="index">
                  {{ index + 1 }}、{{ item }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="fixed-change-details-content" v-if="showCheckDetailsType == 2">
        <div class="title">
          示例图纸
          <img
            @click="closeOrOpenFixedCheckDetails(2)"
            class="fixed-change-details-close"
            src="../assets/icon/guanbi@2x.png"
            alt=""
          />
        </div>
        <div class="fixed-change-details-table">
          <div class="material-content" ref="materialc">
            <!-- Swiper -->
            <swiper
              :options="swiperOption"
              :autoplay="false"
              ref="mySwiper_main"
              @slideChangeTransitionEnd="onSwiperIndex"
              style="width: 100%; height: 100%"
            >
              <swiper-slide v-for="(item, index) in sampleDrawings" :key="index">
                <div class="material-item">
                  <img :src="item.image" alt="" />
                </div>
                <div class="toast-material">{{ item.name }}</div>
              </swiper-slide>
            </swiper>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </div>
          <div class="swiper-index-img">
            <swiper
              :options="swiperOption_indexImg"
              ref="mySwiper_tab"
              class="swiper-thumbs"
              style="width: 100%; height: 108px"
            >
              <swiper-slide v-for="(item, index) in sampleDrawings" :key="index">
                <div
                  class="swiper-index-img-item"
                  :class="{ active: activeSwiperIndex == index }"
                  @click="nextIndexSwiper(index)"
                >
                  <img :src="item.image" alt="" />
                </div>
              </swiper-slide>
            </swiper>
            <div class="img-item-button-prev" slot="button-prev"></div>
            <div class="img-item-button-next" slot="button-next"></div>
          </div>
        </div>
      </div>
    </div>
    <mask-guidelines
      v-if="showMaskGuidelines"
      @getDomposition="getDomGuidelines"
      @changeGuidelinesEject="changeGuidelinesEject"
      @getGuidelinesNumber="getGuidelinesNumber"
    ></mask-guidelines>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import maskGuidelines from "../components/maskTechnicalServices.vue";
import "swiper/dist/css/swiper.css";
import { crm_list } from "@/assets/common.js";

/*
 * 验证是否为数字
 */
function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

import {
  // 业态分类
  $place_orderBusiness_type,
  // 获取关联项目和指定产品
  $placeOrderRelation_project,
  // 计算价格
  $place_orderCalculatePrice,
  // 上传图片
  $uploadUploadLarge,
  // 获取文件标识符
  $uploadOnlySplitOn,
  // 上传 大文件 切片上传
  $uploadOnlySplitUpload,
  // 技术服务 /place_order/page * 获取下单信息
  $placeOrderPage,
  //保存草稿
  $placeOrderDraft,
  // 确认下单
  $placeOrderAdd,
  // 实例图纸
  $placeOrderPaper,
  // 获取指引
  $userAuthShowGuide,
  // CRN项目列表
  $crmPlaceOrder,
} from "@/api";

/**
 * 西顿 自从零开发以来， 都是开发周期不够，导致，项目越开发越烂。
 * 对于技术开发维护这方面 有没有优化可言，上层只觉得功能能用就行。
 * 设计下单，为表单识别与价格联动，除了下单人信息 图纸上传 外 其他表单填写都会涉及到价格联动，计算价格
 * 地址栏链接 参数 > 草稿接口参数 > 默认参数
 */
export default {
  components: {
    swiper,
    swiperSlide,
    maskGuidelines,
  },
  data() {
    // 设计面积校验
    var validateOrderProArea = (rule, value, callback) => {
      if (value <= 0) {
        return callback(new Error("面积不能小于0"));
      } else if (value > 100000) {
        return callback(new Error("设计面积大于十万平方米"));
      } else {
        return callback();
      }
    };

    var vaildateType = (rule, value, callback) => {
      if (this.ruleForm.type == 2 && this.currentRole == 1) {
        return callback(new Error("请选择正确的项目来源"));
      } else {
        return callback();
      }
    };

    const validatorBusiness = (rule, value, callback) => {
      if (this.ruleForm.type == 2 && !value) {
        return callback(new Error("请选择业态类型"));
      } else {
        return callback();
      }
    };

    const validatorOrderName = (rule, value, callback) => {
      console.log(value);

      if (!value) {
        if (this.ruleForm.type == 2) {
          return callback(new Error("请输入项目名称"));
        } else {
          return callback(new Error("请选择项目"));
        }
      }

      // if (this.ruleForm.type != 2) {
      //   if (
      //     !this.crm_projectNameList ||
      //     !this.crm_projectNameList.length ||
      //     (!this.demandServiceList.crm_fafw.length &&
      //       !this.demandServiceList.crm_wcfw.length)
      //   ) {
      //     return callback(new Error("此项目不在设计范围内，无法提交，请结束填写"));
      //   }
      // }
      return callback();
    };

    return {
      //
      pro_nameTimer: null,
      // 下单按钮
      onceChange: false,
      // 文件规格
      suffix_text: [
        "jpg",
        "jpeg",
        "gif",
        "png",
        "bmp",
        "pdf",
        "tif",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "txt",
        "rar",
        "zip",
        "skp",
        "max",
        "dwg",
        "dxf",
        "gz",
        "ppt",
        "pptx",
      ],
      // 图纸示例轮播图
      swiperOption: {
        loop: true,
        thumbs: {
          swiper: {
            el: ".swiper-thumbs", //注意此处的设置方式
            spaceBetween: 10,
            slidesPerView: 4,
            slidesPerGroup: 4,
            watchSlidesVisibility: true /*避免出现bug*/,
          },
        },
        on: {},
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      // 图纸示例轮播图
      swiperOption_indexImg: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 10,
        watchSlidesVisibility: true /*避免出现bug*/,
      },
      un_showNeedTodo: [],
      un_showNeedTodoList: [1, 2, 4, 5],
      selecedCheckDetails: [],
      // 预算价格
      estimatedAmount: {},
      //需求信息说明列表
      checkDetailList: [],
      showCheckDetailsType: 0,
      // 显示 需求明细
      showCheckDetails: false,
      // 显示清空按钮
      showClearFrom: false,
      // 草稿
      draftOrder: {},
      // 用户信息
      userInfo: {},
      //业态分类 主类
      businessClassification: [],
      //业态分类 子类
      businessSubclass: [],
      //关联项目和指定产品
      assoItemsAndSpecPro: {},
      /*  */
      demandServiceList: [],
      // 照度计算
      illuminationCalculation: {},
      // 智能标准方案
      intelligentSolutions: {},
      // ppt 制作方案类型
      pptProductPlanType: {},
      // 效果图
      renderings: {},
      // 设计培训 / 设计类型
      designTraining: {},
      // 方案汇报天数
      programReport: {},
      // 现场技术支持
      technicalSupport: {},
      // 智能售后服务
      afterSalesService: {},
      // 第三方设备对接类型
      externalDeviceDocking: {},
      // 单选 类型 特殊处理
      radioGroupSpecialintroduce: [4, 6, 8, 10, 45, 47],
      // crm智能标准方案
      crmIntelligentSolutions: {},
      // crm户外设计
      crmOutdoor: {},
      // 输入类型 对应id 对应数据
      inputTypeId: {
        3: {
          // 照度计算
          keyValuePair: "illuminationCalculation",
        },
        4: {
          // 智能标准方案
          keyValuePair: "intelligentSolutions",
        },
        6: {
          // ppt 制作方案类型
          keyValuePair: "pptProductPlanType",
        },
        7: {
          // 效果图
          keyValuePair: "renderings",
        },
        8: {
          // 方案汇报天数
          keyValuePair: "programReport",
        },
        9: {
          // 设计培训 / 设计类型
          keyValuePair: "designTraining",
        },
        10: {
          // 现场技术支持
          keyValuePair: "technicalSupport",
        },
        11: {
          // 智能售后服务
          keyValuePair: "afterSalesService",
        },
        12: {
          // 第三方设备对接类型
          keyValuePair: "externalDeviceDocking",
        },
        45: {
          // crm智能标准方案
          keyValuePair: "crmIntelligentSolutions",
        },
        // crm户外设计
        47: {
          keyValuePair: "crmOutdoor",
        },
      },
      /*  */
      // 附件 上传
      fileList: [],
      integratedSuffix: [".png", ".jpg", ".jpeg"],
      essentialForm: {
        order_apply_name: "", // 姓名
        order_phone: "", // 手机
        order_email: "", // 邮箱
      },
      // 基本填写信息
      ruleForm: {
        order_apply_name: "", // 姓名
        order_phone: "", // 手机
        order_email: "", // 邮箱
        order_business: "", // 项目业态 住宅类型
        order_child_business: "", // 项目业态 建筑类型
        order_pro_name: "", // 项目名称
        order_pro_area: "", // 设计面积
        order_bind_id: "", // 相关项目
        order_assign_pro: "", // 指定产品
        order_assign_id: "", // 指定产品 id
        order_pro_remark: "", // 备注
        type: "2", // 项目来源
        order_type: "2", //
      },
      // 基本填写信息 校验
      rules: {
        order_apply_name: [
          { required: true, message: "请输入您的姓名", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        order_phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            validator: function checkMobile(rule, phone, callback) {
              const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
              if (phone == "" || phone.length <= 10 || !reg.test(phone)) {
                return callback(new Error("请检查手机号码"));
              } else {
                return callback();
              }
            },
          },
        ],
        order_email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        order_business: [{ required: true, message: "请选择业态", trigger: "change" }],
        order_child_business: [
          { required: true, message: "请选择业态类型", trigger: "change" },
          // {
          //   validator: validatorBusiness,
          //  trigger:"change"
          // }
        ],
        order_pro_name: [
          //   { required: true, message: "请输入项目名称", trigger: "blur" },
          {
            validator: validatorOrderName,
            trigger: ["blur", "change"],
          },
          {
            min: 3,
            max: 256,
            message: "长度在 3 到 256 个字符",
            trigger: ["blur", "change"],
          },
        ],
        order_pro_area: [
          { required: true, message: "请输入设计面积", trigger: "blur" },
          { validator: validateOrderProArea, trigger: "change" },
        ],
        type: [
          {
            required: true,
            message: "请选择项目来源",
            trigger: ["blur", "change"],
          },
          { validator: vaildateType, trigger: "change" },
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          //只能选择今天及今天之前的日期
          // return time.getTime() > Date.now();
          //只能选择今天及今天之后的日期
          return time.getTime() < Date.now() - 8.64e6; //只能选择今天之后的日期，今天的日期也不能选
        },
      },

      // 选择 服务信息
      serveForm: {
        // 方案服务
        solutionService: [],
        // 外出服务
        outboundService: [],
      },
      // 外出地址
      order_dian_address: "",
      // 外出时间
      order_dian_time: "",
      serveForm_id: [],
      // 需求服务
      order_require_design: [],
      // 示例图纸
      sampleDrawings: [],
      activeSwiperIndex: 0,

      // 显示隐藏 指引
      showMaskGuidelines: false,
      MaskGuidelinesNumber: 0,
      //项目来源
      // projectSourceList: [
      // 	{
      // 		id: 'crmsub_1',
      // 		name: 'CRM商机',
      // 	},
      // 	{
      // 		id: 'crmsub_2',
      // 		name: 'CRM线索',
      // 	},
      // 	{
      // 		id: '2',
      // 		name: '其他',
      // 	},
      // ],
      // 地址栏参数
      addressBarParma: null,
      // 当前使用角色
      currentRole: null,
      // 是否为OA 0为OA号 1/null为普通号
      is_oa: null,
      // 历史草稿
      history: {},
      // 来源id
      crm_id: "",
      init_crm_id: "",
      // 项目名称列表
      crm_projectNameList: [],
      // crm 等级信息
      crm_synthesis: {},
      //
      infiniteProjectName: true,
      //
      infiniteProjectNamePage: 1,
      //
      infiniteProjectNameRows: 150,
      showSelectProjectName: false,
      infiniteProjectNameSearch: "",
      infiniteProjectNameLoading: false,

      showDemandTitle: false,
    };
  },
  computed: {
    projectSourceList() {
      const arr = [
        {
          id: "crmsub_1",
          name: "CRM商机",
        },
        {
          id: "crmsub_2",
          name: "CRM线索",
        },
      ];
      if (this.currentRole && this.currentRole != 1) {
        arr.push({
          id: "2",
          name: "其他",
        });
      }

      return arr;
    },
    // 基本申请人
    enterName() {
      return this.ruleForm.order_apply_name;
    },
    // 基本申请人手机号码
    enterMobile() {
      return this.ruleForm.order_phone;
    },
    // 基本申请人
    enterMail() {
      return this.ruleForm.order_email;
    },
    typeDisabled() {
      console.log(this.is_oa, this.currentRole);
      if (this.is_oa == 1 || this.is_oa === null) {
        return true;
      } else if (this.currentRole == 6) {
        return true;
      } else {
        return false;
      }
    },
    isDealer() {
      return this.currentRole == 1;
    },
    showDemandToast() {
      let has_solution = this.serveForm.solutionService.find((item) => {
        return item.child.find((k) => {
          return k.dw_name;
        });
      });
      let has_outbound = this.serveForm.outboundService.find((item) => {
        return item.child.find((k) => {
          return k.dw_name;
        });
      });
      let result_has = has_solution || has_outbound;
      return result_has ? true : false;
    },
    isLocalcrm() {
      return !!this.$route.query.localcrm;
    },
  },
  watch: {
    demandServiceList: {
      handler: function (val) {
        let { crm_fafw = [], crm_wcfw = [], fafw = [], wcfw = [] } = val;
        let c_fw = [...crm_fafw, ...crm_wcfw];
        let d_fw = [...fafw, ...wcfw];
        this.showDemandTitle =
          this.ruleForm.type == 1 ? c_fw.length > 0 : d_fw.length > 0;
      },
      // 深度观察监听
      deep: true,
    },
    enterName(newVal) {
      this.essentialForm.order_apply_name = newVal;
    },
    enterMobile(newVal) {
      this.essentialForm.order_phone = newVal;
    },
    enterMail(newVal) {
      this.essentialForm.order_email = newVal;
    },
    // 基本信息
    ruleForm: {
      handler: function (val, oldVal) {
        let formNameGroup = Object.keys(val);
        let checkout = [];
        formNameGroup.forEach((item) => {
          if (val[item] != "" || val[item]) {
            checkout.push(true);
          } else {
            checkout.push(false);
          }
        });
        if (checkout.indexOf(true) != -1) {
          this.showClearFrom = true;
        } else {
          this.showClearFrom = false;
        }
      },
      // 深度观察监听
      deep: true,
    },
    "ruleForm.order_pro_name": function (ev) {
      if (ev) {
        if (this.pro_nameTimer) {
          clearTimeout(this.pro_nameTimer);
        }
        this.pro_nameTimer = setTimeout(() => {
          $placeOrderRelation_project({
            project_name: ev,
          }).then((res) => {
            if (res) {
              this.assoItemsAndSpecPro = res.data;
              this.ruleForm.order_bind_id = "";
              let result = this.assoItemsAndSpecPro.project.find((item) => {
                return this.history.order_bind_id == item.id;
              });
              if (result) {
                this.ruleForm.order_bind_id = String(result.id);
              }
            }
          });
        }, 400);
      }
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  async mounted() {
    // 获取链接参数
    this.$nextTick(() => {
      // 获取当前权限
      this.getCurrentRole();
      // // 请求 获取 项目申请人信息
      this.getCrmPlaceOrder();
    });
    this.showSelectProjectName = true;
    try {
      // 获取链接参数
      let param = await this.getURLParam();
      this.addressBarParma = { ...param };
    } catch (error) {
      console.log(error);
      this.addressBarParma = null;
    }
    // 获取 选择数据
    this.getSelectTypeAndServices({
      status: this.crm_id ? "crm" : "",
    });
    // this.getDraftOrderOrUserInfo();

    // 实例图纸
    $placeOrderPaper({}).then((res) => {
      if (res) {
        this.sampleDrawings = res.data;
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    // 获取当前权限
    getCurrentRole() {
      // 用户身份
      this.currentRole = this.$store.state.userInfo.user_code || null;
      this.is_oa = this.$store.state.userInfo.is_oa || null;
      if (this.is_oa == 0 && this.currentRole == 1) {
        this.ruleForm.type = "1";
        this.ruleForm.order_type = "crmsub_1";
      }
    },

    // 获取链接参数
    getURLParam() {
      // project_level=v1&project_type=战略客户&customer_level=S
      let { localcrm } = this.$route.query;
      let order_data =
        localcrm && this.$store.state.crminfo_cd == localcrm
          ? this.$store.state.crminfo
          : this.$route.query;
      let {
        type = "",
        business = "",
        second_business = "",
        project_name = "",
        crm_id = "",
        order_place_name = "",
        order_place_mobile = "",
        order_place_email = "",
        project_level = "",
        project_type = "",
        customer_level = "",
        crm_order_type_sub = "",
      } = order_data;
      // // 去空格 解码
      order_place_name = decodeURIComponent(order_place_name);
      order_place_mobile = decodeURIComponent(order_place_mobile);
      order_place_email = decodeURIComponent(order_place_email);
      return new Promise((resolve, reject) => {
        if (type && crm_id) {
          this.crm_id = crm_id;
          this.init_crm_id = crm_id;
          this.crm_synthesis = Object.assign(this.crm_synthesis, {
            project_level,
            project_type,
            customer_level,
          });
          resolve({
            type,
            business,
            second_business,
            project_name,
            order_place_name,
            order_place_mobile,
            order_place_email,
            crm_order_type_sub,
            order_type: crm_order_type_sub ? "crmsub_" + crm_order_type_sub : "crmsub_1",
          });
        } else {
          reject(null);
        }
      });
    },
    // 选择项目名称
    getProjectNameList() {
      if (this.infiniteProjectName) {
        this.infiniteProjectNamePage++;
        this.getCrmPlaceOrder(this.infiniteProjectNameSearch);
      }
    },
    // 请求 获取 项目申请人信息
    getCrmPlaceOrder(query = "") {
      // OA账号才能 请求
      if (this.is_oa == 1) {
        this.infiniteProjectName = false;
        return;
      }
      if (query) {
        this.infiniteProjectNameSearch = query;
        this.crm_projectNameList = [];
      }
      let { infiniteProjectNamePage, infiniteProjectNameRows } = this.$data;
      this.infiniteProjectNameLoading = true;
      $crmPlaceOrder({
        page: infiniteProjectNamePage,
        limit: infiniteProjectNameRows,
        key: query,
      })
        .then((res) => {
          if (res) {
            if (res.data.length < this.infiniteProjectNameRows) {
              this.infiniteProjectName = false;
            }
            this.crm_projectNameList.push(...res.data);
          }
          this.infiniteProjectNameLoading = false;
        })
        .catch((err) => {
          this.infiniteProjectNameLoading = false;
          console.log(err);
        });
    },
    // 更改 项目来源
    changeProjectSource(ev) {
      if (ev == 2) {
        this.ruleForm.type = 2;
      } else {
        this.ruleForm.type = 1;
      }
      if (this.ruleForm.type == 1) {
        this.crm_id = this.init_crm_id;
        this.ruleForm.order_pro_name = this.addressBarParma
          ? this.addressBarParma.project_name
          : "";
        this.clearSelected();
        this.changeServiceSystem(this.crm_synthesis);
      } else {
        this.crm_id = "";
        // this.ruleForm.order_pro_name = '';
        this.changeServiceSystem();
      }
    },
    // 选择项目名称
    changeProjectName(ev) {
      let data = this.crm_projectNameList.find((item) => {
        return item.name === ev;
      });
      this.crm_id = data._id;
      this.init_crm_id = data._id;
      this.crm_synthesis = Object.assign(this.crm_synthesis, {
        project_level: data.project_level,
        project_type: data.project_type,
        customer_level: data.customer_level,
      });
      this.changeServiceSystem(this.crm_synthesis);
    },

    // 获取是否显示指引
    getAuthShowGuide() {
      const type = {
        0: false,
        1: true,
      };
      $userAuthShowGuide().then((res) => {
        if (res) {
          this.changeGuidelinesEject(type[res.data.is_show_guide]);
        }
      });
    },

    // 更改 显示隐藏指引
    changeGuidelinesEject(type) {
      this.showMaskGuidelines = type;
      this.getGuidelinesNumber(0);
    },
    // 获取当前 指引
    getGuidelinesNumber(num) {
      this.MaskGuidelinesNumber = num;
    },

    // 获取指引Dom位置
    getDomGuidelines(fn = () => {}) {
      // 左边流程图
      let leftProcess = this.$refs["leftProcess"].getBoundingClientRect();
      // 下单人信息
      let essential = this.$refs["essential_info"].getBoundingClientRect();
      // 项目信息
      let ruleForm = this.$refs["ruleForm_info"].getBoundingClientRect();
      // 需求信息
      let serveForm = this.$refs["serveForm_info"].getBoundingClientRect();
      // 图纸上传
      let imgUpload = this.$refs["imgUpload"].getBoundingClientRect();
      // priceSum 价格计算
      let priceSum = this.$refs["priceSum"].getBoundingClientRect();
      // 确认按钮
      let submitBtn = this.$refs["submitBtn"].getBoundingClientRect();
      fn({
        leftProcess,
        essential,
        ruleForm,
        serveForm,
        imgUpload,
        priceSum,
        submitBtn,
      });
    },

    // 切换 示例图纸轮播图
    nextIndexSwiper(index) {
      // console.log(index);
      this.$refs.mySwiper_main.swiper.slideToLoop(index, 500, (val) => {});
      this.$refs.mySwiper_tab.swiper.slideToLoop(index, 500, (val) => {});
    },
    // 示例图纸
    onSwiperIndex(ev) {
      this.activeSwiperIndex = this.$refs.mySwiper_main.swiper.realIndex;
      this.$refs.mySwiper_tab.swiper.slideTo(
        this.$refs.mySwiper_main.swiper.realIndex,
        500,
        false
      ); //切换到第一个slide，速度为1秒
    },
    // 选择 需求服务
    async changeServiceSelect(val, data) {
      // 选择 方案服务（2） 或者 外出服务（3）
      let { solutionService, outboundService } = this.serveForm;
      if (val == 1) {
        if (data.child.length == 1) {
          data.child[0].select = 1;
        }
        this.serveForm_id.push(`${data.id}`);
        // this.repetFilter(true, data.id);
        // 选中 导入
        switch (data.service_type) {
          case "2":
            this.serveForm.solutionService.push(data);
            break;
          case "3":
            this.serveForm.outboundService.push(data);
            break;
        }
        if (!this.showClearFrom) {
          this.showClearFrom = true;
        }
      } else {
        this.serveForm_id.splice(this.serveForm_id.indexOf(`${data.id}`), 1);
        // this.repetFilter(false, data.id);
        // 不选 导出
        let len;
        switch (data.service_type) {
          case "2":
            len = solutionService.length;
            // 查找
            for (let i = 0; i < len; i++) {
              if (solutionService[i].id == data.id) {
                this.serveForm.solutionService.splice(i, 1);
                break;
              }
            }
            // 取出

            break;
          case "3":
            len = outboundService.length;
            // 查找
            for (let i = 0; i < len; i++) {
              if (outboundService[i].id == data.id) {
                this.serveForm.outboundService.splice(i, 1);
                break;
              }
            }
            break;
        }
      }
      this.selecedCheckDetails = [];
      let result = await this.calculateThePrice();
      // this.getCheckDetailTable();
      this.$forceUpdate();
      return result;
    },
    // 获取需求信息说明
    getCheckDetailTable(list) {
      // console.log(this.selecedCheckDetails);
      // this.checkDetailList = list.map((item) => {
      //   let { name } = item;
      //   return { name };
      // });
    },
    async changeOrderProArea(val) {
      if (val > 100000) {
        this.$message({
          message: "设计面积大于十万平方米，请联系设计岛客服单独报价。",
          type: "warning",
        });
      }

      if (val) {
        let result = await this.calculateThePrice();
      }
    },
    // 获取 选择数据
    getSelectTypeAndServices(ev = {}) {
      let { status = "" } = ev;

      let parmas = {};
      if (status == "crm") {
        // this.crm_synthesis
        parmas = { is_crm: "1", ...this.crm_synthesis };
      } else {
        parmas = { is_crm: "2" };
      }
      // 加载
      const loading = this.$loading({
        lock: true,
        text: "加载中，请耐心等待....",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // 业态分类
      $place_orderBusiness_type({})
        .then((res) => {
          if (res) {
            // console.log("业态分类", res);
            this.businessClassification = res.data;
            this.ruleForm.order_business = res.data[0].id;
            this.businessSubclass = res.data[0].children;
            if (res.data[0].children.length > 0) {
              this.ruleForm.order_child_business = res.data[0].children[0].id;
            } else {
              this.ruleForm.order_child_business = "";
            }
          }
          // 获取关联项目和指定产品
          return $placeOrderRelation_project({
            project_name: "",
          });
        })
        .then((res) => {
          if (res) {
            this.assoItemsAndSpecPro = res.data;
          }
          // 技术服务 /place_order/page * 获取下单信息
          return $placeOrderPage(parmas);
        })
        .then(async (res) => {
          if (res) {
            this.serveForm.solutionService = [];
            this.serveForm.outboundService = [];
            try {
              if (res.data.order_info && !this.isLocalcrm) {
                // 抽取 草稿的订单基本信息
                this.getDraftOrder_info(res.data.order_info);
              }
            } catch (error) {
              // console.log(error);
            }
            this.urlDataSetOrder_info();
            this.demandServiceList = res.data;
            

            let lael_name_program = {};
            let circulate_fafw =
              this.ruleForm.type == 2 ? res.data.fafw : res.data.crm_fafw;

            for (let i = 0; i < circulate_fafw.length; i++) {
              let item = circulate_fafw[i];
              let index = i;
              let radioGroupSelectedVal;
              if (this.inputTypeId[item.id]) {
                if (this.radioGroupSpecialintroduce.indexOf(item.id) != -1) {
                  for (let i = 0; i < item.child.length; i++) {
                    if (item.child[i].select == 1) {
                      radioGroupSelectedVal = item.child[i].id;
                      break;
                    }
                  }
                }

                let radioGroup;
                if (radioGroupSelectedVal && radioGroupSelectedVal > 0) {
                  radioGroup = radioGroupSelectedVal;
                } else {
                  radioGroup = "";
                }

                this.$set(this.$data, this.inputTypeId[item.id].keyValuePair, {
                  ...item,
                  radioGroup,
                  checkbox: [],
                });
              }

              lael_name_program[`${item.id}`] = item.name;
              if (item.select == 1) {
                await this.changeServiceSelect(1, item);
              }
            }
            let circulate_wcfw =
              this.ruleForm.type == 2 ? res.data.wcfw : res.data.crm_wcfw;
            for (let i = 0; i < circulate_wcfw.length; i++) {
              let item = circulate_wcfw[i];
              let index = i;
              let radioGroupSelectedVal;

              try {
                if (this.inputTypeId[item.id]) {
                  if (this.radioGroupSpecialintroduce.indexOf(item.id) != -1) {
                    for (let i = 0; i < item.child.length; i++) {
                      if (item.child[i].select == 1) {
                        radioGroupSelectedVal = item.child[i].id;
                        break;
                      }
                    }
                  }

                  let radioGroup;
                  if (radioGroupSelectedVal && radioGroupSelectedVal > 0) {
                    radioGroup = radioGroupSelectedVal;
                  } else {
                    radioGroup = "";
                  }
                  this.$set(this.$data, this.inputTypeId[item.id].keyValuePair, {
                    ...item,
                    radioGroup,
                    checkbox: [],
                  });
                  this.$forceUpdate();
                }
                lael_name_program[`${item.id}`] = item.name;
              } catch (error) {
                // console.log(error);
              }

              if (item.select == 1) {
                await this.changeServiceSelect(1, item);
              }
            }
          }
          // 加载结束
          loading.close();
          this.$forceUpdate();
          if (this.ruleForm.type == 1) {
            this.clearSelectedServe();
          }

          // 获取是否显示指引
          this.getAuthShowGuide();
        })
        .catch(async (err) => {
          // console.log(err);
          if (err == "关联订单未找到") {
            this.ruleForm.order_bind_id = "";
            this.clearSelected();
          }
          // 加载结束
          loading.close();
        });
    },

    // 更改 服務系統 只修改 需求服務
    changeServiceSystem(par = {}) {
      const loading = this.$loading({
        lock: true,
        text: "加载中，请耐心等待....",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      // 选择 服务信息
      this.clearSelectedServe();

      let param = {
        is_crm: this.crm_id ? 1 : 2,
      };

      if (this.crm_id && this.ruleForm.type == 1) {
        param.project_level = par.project_level || "";
        param.project_type = par.project_type || "";
        param.customer_level = par.customer_level || "";
      }
      return new Promise((resolve, reject) => {
        this.$set(this.demandServiceList, "crm_wcfw", []);
        this.$set(this.demandServiceList, "crm_fafw", []);
        $placeOrderPage(param)
          .then(async (res) => {
            
            this.demandServiceList = Object.assign(this.demandServiceList, {
              wcfw: res.data.wcfw || [],
              fafw: res.data.fafw || [],
              crm_wcfw: res.data.crm_wcfw || [],
              crm_fafw: res.data.crm_fafw || [],
            });
            
            
            if (
              this.ruleForm.type == 1 &&
              !this.demandServiceList.crm_wcfw.length &&
              !this.demandServiceList.crm_fafw.length
            ) {
              this.$confirm("此项目不在设计范围内，无法提交，请结束填写!", "提示", {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "warning",
              });
            }

            let lael_name_program = {};
            let circulate_fafw =
              this.ruleForm.type == 2 ? res.data.fafw : res.data.crm_fafw;

            for (let i = 0; i < circulate_fafw.length; i++) {
              let item = circulate_fafw[i];
              let radioGroupSelectedVal;
              if (this.inputTypeId[item.id]) {
                if (this.radioGroupSpecialintroduce.indexOf(item.id) != -1) {
                  for (let i = 0; i < item.child.length; i++) {
                    if (item.child[i].select == 1) {
                      radioGroupSelectedVal = item.child[i].id;
                      break;
                    }
                  }
                }

                let radioGroup;
                if (radioGroupSelectedVal && radioGroupSelectedVal > 0) {
                  radioGroup = radioGroupSelectedVal;
                } else {
                  radioGroup = "";
                }

                this.$set(this.$data, this.inputTypeId[item.id].keyValuePair, {
                  ...item,
                  radioGroup,
                  checkbox: [],
                });
              }

              lael_name_program[`${item.id}`] = item.name;
              if (item.select == 1) {
                await this.changeServiceSelect(1, item);
              }
            }
            let circulate_wcfw =
              this.ruleForm.type == 2 ? res.data.wcfw : res.data.crm_wcfw;
            for (let i = 0; i < circulate_wcfw.length; i++) {
              let item = circulate_wcfw[i];
              let radioGroupSelectedVal;

              try {
                if (this.inputTypeId[item.id]) {
                  if (this.radioGroupSpecialintroduce.indexOf(item.id) != -1) {
                    for (let i = 0; i < item.child.length; i++) {
                      if (item.child[i].select == 1) {
                        radioGroupSelectedVal = item.child[i].id;
                        break;
                      }
                    }
                  }

                  let radioGroup;
                  if (radioGroupSelectedVal && radioGroupSelectedVal > 0) {
                    radioGroup = radioGroupSelectedVal;
                  } else {
                    radioGroup = "";
                  }
                  this.$set(this.$data, this.inputTypeId[item.id].keyValuePair, {
                    ...item,
                    radioGroup,
                    checkbox: [],
                  });
                  this.$forceUpdate();
                }
                lael_name_program[`${item.id}`] = item.name;
              } catch (error) {
                // console.log(error);
              }

              if (item.select == 1) {
                await this.changeServiceSelect(1, item);
              }
            }
            loading.close();
            resolve();
            this.$forceUpdate();
          })
          .catch(() => {
            loading.close();
          });
      });
    },

    urlDataSetOrder_info() {
      let { localcrm } = this.$route.query;
      let can_add_crm = localcrm && this.$store.state.crminfo_cd == localcrm;
      if (this.addressBarParma && can_add_crm) {
        console.log(this.addressBarParma);
        try {
          this.ruleForm.order_business =
            this.addressBarParma.business && isNumber(this.addressBarParma.business)
              ? Number(this.addressBarParma.business)
              : "";
          this.ruleForm.order_child_business =
            this.addressBarParma.second_business &&
            isNumber(this.addressBarParma.second_business)
              ? Number(this.addressBarParma.second_business)
              : "";
          this.ruleForm.order_apply_name = this.addressBarParma.order_place_name || "";
          this.ruleForm.order_email = this.addressBarParma.order_place_email || "";
          this.ruleForm.order_phone = this.addressBarParma.order_place_mobile || "";

          if (this.addressBarParma.project_name) {
            this.ruleForm.order_pro_name = this.addressBarParma.project_name;
          }
          this.ruleForm.type = this.addressBarParma.type || "2";
          this.ruleForm.order_type = this.addressBarParma.order_type || "2";
          console.log(this.ruleForm.order_child_business, this.ruleForm.order_business);
        } catch (error) {
          console.log(error);
        }
        this.fileList = [];
      }
      if (this.is_oa == 1) {
        this.ruleForm.type = "2";
        this.ruleForm.order_type = "2";
      }
      if (this.currentRole == 1 && this.ruleForm.order_type == 2) {
        this.ruleForm.order_type = "";
      }

      let is_order_business;
      try {
        if (this.ruleForm.order_business) {
          is_order_business = this.businessClassification.find((item) => {
            return item.id == this.ruleForm.order_business;
          });
          if (is_order_business) {
            let child = this.ruleForm.order_child_business;
            // 更改 业态主类
            this.changeBusinessClass(this.ruleForm.order_business);
            this.ruleForm.order_business = Number(this.ruleForm.order_business);
            this.ruleForm.order_child_business = child;
            // 项目业态 建筑类型
            if (child) {
              this.ruleForm.order_child_business = Number(
                this.ruleForm.order_child_business
              );
              // 更改 业态子类
              this.changeBusinessSubclass(this.ruleForm.order_business);
            }
          } else {
            this.ruleForm.order_business = "";
            this.ruleForm.order_child_business = "";
          }
        }
      } catch (error) {
        // console.log(error);
      }
    },

    // 抽取 草稿的订单基本信息
    getDraftOrder_info(data) {
      let {
        order_apply_name,
        order_business,
        order_child_business,
        order_dian_address,
        order_dian_time,
        order_require_file,
        order_email,
        order_bind_id,
        order_assign_id,
        order_phone,
        order_pro_area,
        order_pro_name,
        order_pro_remark,
        crm_id = "",
        type = "0",
        crm_order_type_sub,
      } = data;
      this.history = data;
      this.crm_id = this.crm_id || crm_id;
      this.init_crm_id = this.crm_id || crm_id;
      // 姓名
      this.ruleForm.order_apply_name = order_apply_name;
      // 项目业态 住宅类型
      // console.log(order_business, order_child_business);
      this.ruleForm.order_business = order_business;
      this.ruleForm.order_child_business = order_child_business;
      // order_place_name = "",
      // order_place_mobile = "",
      // order_place_email = "",
      this.ruleForm.type = type || "2";
      this.ruleForm.order_type = crm_order_type_sub
        ? "crmsub_" + crm_order_type_sub
        : "2";
      // 邮箱
      this.ruleForm.order_email = order_email;
      // 相关项目
      this.ruleForm.order_bind_id = order_bind_id ? String(order_bind_id) : "";
      // 指定产品
      this.ruleForm.order_assign_pro = order_assign_id || "";
      // 手机
      this.ruleForm.order_phone = order_phone;
      // 设计面积
      this.ruleForm.order_pro_area = order_pro_area;
      // 项目名称
      this.ruleForm.order_pro_name = order_pro_name;
      // 备注
      this.ruleForm.order_pro_remark = order_pro_remark;
      // 外出地址
      this.order_dian_address = order_dian_address;
      // 外出时间
      this.order_dian_time = order_dian_time;
      if (order_require_file) {
        this.$data.fileList = order_require_file.map((item) => {
          item.upping = false;
          item.progress = 100;
          return item;
        });
      }

      this.$forceUpdate();
      return this.ruleForm;
    },
    changeDatePicker(fomrat) {
      // console.log(fomrat);
    },
    // 重置 表单信息
    resetForm() {
      // 清空 用户基本信息表单
      this.$refs["ruleForm"].resetFields();
      const orderType = this.ruleForm.order_type;
      // 清空用户需求选择信息
      this.ruleForm = {
        order_apply_name: "", // 姓名
        order_phone: "", // 手机
        order_email: "", // 邮箱
        order_business: "", // 项目业态 住宅类型
        order_child_business: "", // 项目业态 建筑类型
        order_pro_name: "", // 项目名称
        order_pro_area: "", // 设计面积
        order_bind_id: "", // 相关项目
        order_assign_pro: "", // 指定产品
        order_assign_id: "", // 指定产品 id
        order_pro_remark: "", // 备注
        type: "2",
        order_type: "2",
      };
      if (this.is_oa == 0 && this.currentRole == 1) {
        this.ruleForm.type = "1";
        this.ruleForm.order_type = orderType == "crmsub_2" ? "crmsub_2" : "crmsub_1";
      } else if (this.is_oa == 1) {
        this.ruleForm.type = "2";
        this.ruleForm.order_type = "2";
      }
      // 隐藏清除按钮
      this.showClearFrom = false;
      this.clearSelected();
    },
    // 获取 草稿 或  用户信息
    getDraftOrderOrUserInfo() {
      let { userInfo } = this.$store.state;
      this.userInfo = userInfo;
      let { real_name, user_phone, user_Email } = userInfo;
      this.ruleForm.order_apply_name = real_name;
      this.ruleForm.order_phone = user_phone;
      this.ruleForm.order_email = user_Email;
    },
    /**
     * form表单操作
     */

    // 更改 业态主类
    changeBusinessClass(val) {
      if (val) {
        try {
          // 查找
          let result = this.businessClassification.find(function (item) {
            return item.id == val;
          });
          // console.log("val", val, result);
          // 子类赋值
          if (result) {
            this.businessSubclass = result.children;
            this.ruleForm.order_child_business = "";
          }
        } catch (error) {
          // console.log(error);
        }
      } else {
        this.businessSubclass = [];
      }
    },
    // 更改 业态子类
    async changeBusinessSubclass(val) {
      if (val) {
        let priceList = [
          ...this.serveForm.solutionService,
          ...this.serveForm.outboundService,
        ];

        if (priceList.length > 0) {
          let result = await this.calculateThePrice();
        }
      } else {
        this.estimatedAmount = {};
      }
    },
    // 更改 相关项目
    async changeSelectedOrderBindId(val) {
      let priceList = [
        ...this.serveForm.solutionService,
        ...this.serveForm.outboundService,
      ];
      if (priceList.length > 0) {
        let result = await this.calculateThePrice();
      }
    },
    /////
    // 单独输入框
    async enterAloneCase(ev, data) {
      if (!ev || ev <= 0) {
        this.$message({
          message: `${data.value.child[0].name}不能为空，不能小于1`,
          type: "warning",
        });
        data.value.child[0].dw_num = 1;
      } else if (ev > 100) {
        this.$message({
          message: `${data.value.child[0].name}不能大于100`,
          type: "warning",
        });
        data.value.child[0].dw_num = 1;
      }
      data.value.child[0].select = 1;
      // 方案或 外出 更改
      this.correspondingIntroduction(ev, data);
      let result = await this.calculateThePrice();

      // 价格计算

      if (!this.showClearFrom && ev) {
        this.showClearFrom = true;
      }
      this.$forceUpdate();
    },
    // 单选按钮
    async chageRadioCase(ev, data) {
      data.value.child.forEach((item) => {
        if (item.id == data.value.radioGroup) {
          item.select = 1;
        } else {
          item.select = 0;
        }
      });
      // 方案或 外出 更改
      this.correspondingIntroduction(ev, data);
      // console.log("单选按钮", ev, data);
      // 价格计算
      let result = await this.calculateThePrice();
      if (!this.showClearFrom && ev) {
        this.showClearFrom = true;
      }
      this.$forceUpdate();
    },
    // 单选按钮 输入框
    async chageRadioInput(ev, data) {
      if (!ev || ev <= 0) {
        this.$message({
          message: `${data.value.child[data.index].name}不能为空，不能小于1`,
          type: "warning",
        });
        data.value.child[data.index].dw_num = 1;
      } else if (ev > 100) {
        this.$message({
          message: `${data.value.child[data.index].name}不能大于100`,
          type: "warning",
        });
        data.value.child[data.index].dw_num = 1;
      }
      this.correspondingIntroduction(ev, data);
      let result = await this.calculateThePrice();
      if (!this.showClearFrom && ev) {
        this.showClearFrom = true;
      }
      this.$forceUpdate();
    },
    // 多选按钮
    async changeCheckBoxCase(ev, data) {
      // console.log("多选按钮", ev, data);
      this.correspondingIntroduction(ev, data);
      let result = await this.calculateThePrice();
      if (!this.showClearFrom && ev) {
        this.showClearFrom = true;
      }
      this.$forceUpdate();
    },
    // 多选 按钮 输入框
    async changeCheckBoxInput(ev, data) {
      if (!ev || ev <= 0) {
        this.$message({
          message: `${data.value.child[data.index].name}不能为空，不能小于1`,
          type: "warning",
        });
        data.value.child[data.index].dw_num = 1;
      } else if (ev > 100) {
        this.$message({
          message: `${data.value.child[data.index].name}不能大于100`,
          type: "warning",
        });

        data.value.child[data.index].dw_num = 1;
      }
      this.correspondingIntroduction(ev, data);
      let result = await this.calculateThePrice();
      if (!this.showClearFrom && ev) {
        this.showClearFrom = true;
      }
      this.$forceUpdate();
    },
    // 对应引入
    correspondingIntroduction(ev, data) {
      let { solutionService, outboundService } = this.$data.serveForm;
      let len = solutionService.length;
      let len_1 = outboundService.length;

      switch (data.value.service_type) {
        case "2":
          for (let i = 0; i < len; i++) {
            if (solutionService[i].id == data.value.id) {
              this.serveForm.solutionService[i] = data.value;
              break;
            }
          }
          break;
        case "3":
          for (let i = 0; i < len_1; i++) {
            if (outboundService[i].id == data.value.id) {
              this.serveForm.outboundService[i] = data.value;
              break;
            }
          }
          break;
      }
    },
    // 关闭 需求明细
    closeOrOpenFixedCheckDetails(type) {
      this.showCheckDetails = !this.showCheckDetails;
      if (this.showCheckDetails) {
        this.showCheckDetailsType = type;
      } else {
        this.showCheckDetailsType = 0;
      }
    },

    /**
     * crm 非价格计算
     */
    async crm_calculateThePrice() {
      try {
        let { ruleForm } = this.$data;
        let order_require_design = [];
        return new Promise((resolve, reject) => {
          this.$refs["ruleForm"].validate(async (valid) => {
            if (valid) {
              order_require_design = await this.integrationRequirements();
              if (order_require_design.length == 0) {
                this.estimatedAmount = {};
                this.$forceUpdate();
                return order_require_design;
              }
              resolve(order_require_design);
              return order_require_design;
              // let parmas = {
              //   order_area: ruleForm.order_pro_area,
              //   order_business_id: ruleForm.order_business || 0,
              //   order_child_business_id: ruleForm.order_child_business || 0,
              //   order_bind_id: ruleForm.order_bind_id || 0,
              //   order_require_design,
              // };
              // try {
              //   let result = await $place_orderCalculatePrice(parmas);
              //   if (result.code == 200) {
              //     this.estimatedAmount = result.data;
              //     resolve(result);
              //     this.$forceUpdate();
              //   } else {
              //     reject();
              //   }
              // } catch (error) {
              //   reject(error);
              // }
            } else {
              resolve();
              return false;
            }
          });
        });
      } catch (err) {
        // console.log(err);
      }
    },

    /////
    /**
     * form表单操作 end
     */
    // 计算价格
    async calculateThePrice() {
      try {
        let { ruleForm } = this.$data;
        let order_require_design = [];
        return new Promise((resolve, reject) => {
          this.$refs["ruleForm"].validate(async (valid, obj) => {
            console.log(obj);
            var len = Object.keys(obj).length;

            let tool = false;
            if ("order_pro_name" in obj && len === 1) {
              tool = true;
            }
            if (valid || tool) {
              order_require_design = await this.integrationRequirements();
              if (order_require_design.length == 0) {
                this.estimatedAmount = {};
                this.$forceUpdate();
                return;
              }

              if (this.crm_id && this.ruleForm.type == 1) {
                resolve(order_require_design);
                this.$forceUpdate();
              } else {
                let parmas = {
                  order_area: ruleForm.order_pro_area,
                  order_business_id: ruleForm.order_business || 0,
                  order_child_business_id: ruleForm.order_child_business || 0,
                  order_bind_id: ruleForm.order_bind_id || 0,
                  order_require_design,
                };
                try {
                  let result = await $place_orderCalculatePrice(parmas);
                  if (result.code == 200) {
                    this.estimatedAmount = result.data;
                    resolve(result);
                    this.$forceUpdate();
                  } else {
                    reject();
                  }
                } catch (error) {
                  reject(error);
                }
              }
            } else {
              resolve();
              return false;
            }
          });
        });
      } catch (err) {
        // console.log(err);
      }
    },
    // 整合需求
    integrationRequirements() {
      let { serveForm } = this.$data;
      let complexList = [...serveForm.solutionService, ...serveForm.outboundService];
      let order_require_design = [];
      let selectedData = [];
      complexList
        .map((item) => {
          // item.child = item.child.map((key) => {
          //   key.relation_id = item.service_type;
          //   return key;
          // });
          return item.child;
        })
        .flat()
        .forEach((item) => {
          let { id, relation_id, dw_num, name, dw_name } = item;
          if (item.select == 1) {
            selectedData.push(item);
            order_require_design.push({
              id,
              relation_id,
              dw_num,
              dw_name,
              option: name,
            });
          }
        });
      this.selecedCheckDetails = selectedData;
      this.order_require_design = order_require_design;
      console.log("777777777777", JSON.stringify(this.order_require_design));
      return order_require_design;
    },

    essentialSync() {
      return new Promise((resolve, reject) => {
        this.$refs["essential"].validate((valid, failData) => {
          if (!valid) {
            let message = failData[Object.keys(failData)[0]][0].message;
            this.$message.error(message);
            resolve({ msg: false });
            return false;
          } else {
            resolve({ msg: true });
            return true;
          }
        });
      });
    },

    // 确认下单
    async submitForm(formName) {
      let { outboundService, solutionService } = this.serveForm;
      let { order_dian_address, order_dian_time, fileList } = this.$data;

      let essentialPassage = await this.essentialSync();
      if (!essentialPassage.msg) return;

      this.$refs[formName].validate(async (valid, failData) => {
        if (!valid) {
          let message = failData[Object.keys(failData)[0]][0].message;
          switch (Object.keys(failData)[0]) {
            case "order_pro_area":
              message =
                message == "设计面积大于十万平方米"
                  ? "设计面积大于十万平方米，请联系设计岛客服单独报价。"
                  : failData[Object.keys(failData)[0]][0].message;
              break;
            default:
              message = message || "有必填信息未填";
              break;
          }
          this.$message.error(message);
        }
        if (valid) {
          if (outboundService.length > 0) {
            if (!order_dian_address) {
              this.$message.error("请输入外出地址");
              return;
            }
            if (!order_dian_time) {
              this.$message.error("请输入外出时间");
              return;
            }
          } else if (outboundService.length == 0) {
            this.$data.order_dian_address = "";
            this.$data.order_dian_time = "";
          }
          if (this.order_require_design.length <= 0) {
            this.$message.error("请完善需求服务信息");
            return;
          }
          if (fileList.length == 0) {
            this.$message.error("请上传图纸");
            return;
          }

          let complexList = [...solutionService, ...outboundService];
          let len = complexList.length;
          for (let i = 0; i < len; i++) {
            let isSelect = complexList[i].child.find((item) => {
              return item.select;
            });

            if (!isSelect) {
              this.$message.error(`请选择${complexList[i].name}需求！`);
              return [];
            }
          }

          this.$confirm("信息是否确认无误,是否确认下单", "提示", {
            confirmButtonText: "确定",
            confirmButtonClass: "color-red",
            cancelButtonText: "取消",
            cancelButtonClass: "cance-btn",
            type: "warning",
          })
            .then(async () => {
              this.onceChange = true;
              let parmas = await this.getParmasData();
              console.log(parmas);

              $placeOrderAdd(parmas)
                .then((res) => {
                  if (res) {
                    this.$alert("下单成功", "系统提示", {
                      confirmButtonText: "确定",
                      confirmButtonClass: "color-red",
                      cancelButtonClass: "cance-btn",
                      callback: (action) => {
                        // this.$router.go(-1);

                        this.$router.push({
                          path: "/ordermanage",
                          query: {
                            type: 0,
                          },
                        });
                      },
                    });
                  }
                  this.onceChange = false;
                })
                .catch((err) => {
                  this.onceChange = false;
                });
            })
            .catch((err) => {
              // console.log(err);
              this.onceChange = false;
            });
        } else {
          return false;
        }
      });
    },
    // 保存草稿
    async saveForm() {
      let essentialPassage = await this.essentialSync();
      if (!essentialPassage.msg) return;

      this.$refs["ruleForm"].validate(async (valid) => {
        if (valid) {
          let parmas = await this.getParmasData();
          $placeOrderDraft(parmas).then((res) => {
            // console.log(res);
            // this.$alert("保存成功", "系统提示", {
            //   confirmButtonText: "确定",
            //   callback: (action) => {},
            // });
            this.$message({
              message: "保存成功！",
              type: "success",
              callback: (action) => {},
            });
            setTimeout(() => {
              window.location.reload();
            }, 500);
          });
        } else {
          return false;
        }
      });

      // console.log(parmas);
    },
    async getParmasData() {
      let {
        ruleForm,
        order_dian_time,
        order_dian_address,
        order_require_design,
      } = this.$data;
      console.log(order_require_design);

      let {
        order_child_business,
        order_business,
        order_pro_area,
        order_bind_id,
        order_pro_remark,
        order_pro_name,
        order_assign_pro,
        order_apply_name,
        order_phone,
        type,
        order_type,
      } = ruleForm;

      let parmas = {};
      let order_require_file = await this.uploadImage();
      // 外出时间
      parmas.order_dian_time = order_dian_time;
      parmas.type = type;
      if (type == 1) {
        parmas.crm_order_type_sub = order_type === "crmsub_1" ? 1 : 2;
      } else {
        parmas.crm_order_type_sub = "";
      }
      // 外出地址
      parmas.order_dian_address = order_dian_address;
      //设计 需求
      // if (order_require_design.length > 0) {
      parmas.order_require_design = order_require_design;
      // }
      // 业态 子类
      // if (order_child_business) {
      parmas.order_child_business_id = order_child_business;
      // }
      // 业态 大类
      // if (order_business) {
      parmas.order_business_id = order_business;
      // }
      // 备注
      // if (order_pro_remark) {
      parmas.order_pro_remark = order_pro_remark;
      // }
      // 关联订单
      // if (order_bind_id) {
      parmas.order_bind_id = order_bind_id;
      // }
      // 设计面积
      // if (order_pro_area) {
      parmas.order_pro_area = order_pro_area;
      // }
      // 项目名称
      // if (order_pro_name) {
      parmas.order_pro_name = order_pro_name;
      // }
      // 申请人姓名
      // if (order_apply_name) {
      parmas.order_apply_name = order_apply_name;
      // }
      // 手机号
      // if (order_phone) {
      parmas.order_phone = order_phone;
      // }
      // 指定产品
      if (order_assign_pro) {
        parmas.order_assign_id = ruleForm.order_assign_pro;
      }
      // 邮箱
      if (ruleForm.order_email) {
        parmas.order_email = ruleForm.order_email;
      }
      // 附件
      if (order_require_file.length > 0) {
        parmas.order_require_file = order_require_file;
      }
      if (this.crm_id && type == 1) {
        parmas.crm_id = this.crm_id;
        parmas.project_type = this.crm_synthesis.project_type;
        parmas.project_level = this.crm_synthesis.project_level;
        parmas.customer_level = this.crm_synthesis.customer_level;
      }
      return parmas;
    },
    onBeforeUpload(val) {
      // console.log("onBeforeUpload", val);
    },

    clearSelected() {
      // 外出地址
      this.order_dian_address = "";
      // 外出时间
      this.order_dian_time = "";
      // 示例图纸
      // this.sampleDrawings = [];
      this.activeSwiperIndex = 0;

      this.clearSelectedServe();

      //需求信息说明列表
      this.checkDetailList = [];
      this.showCheckDetailsType = 0;
      this.fileList = [];
    },
    // 清除已选服务
    clearSelectedServe() {
      this.serveForm_id = [];
      // 需求服务
      this.order_require_design = [];
      console.log("8888888888888888", JSON.stringify(this.order_require_design));

      // 选择 服务信息
      this.serveForm = {
        // 方案服务
        solutionService: [],
        // 外出服务
        outboundService: [],
      };

      this.demandServiceList.fafw.forEach((item, index) => {
        if (item.select == 1) {
          item.select = 0;
        }
        item.child.forEach((key, i) => {
          if (key.select == 1) {
            key.select = 0;
            key.dw_num = 1;
          }
        });

        let radioGroupSelectedVal;
        if (this.inputTypeId[item.id]) {
          if (this.radioGroupSpecialintroduce.indexOf(item.id) != -1) {
            for (let i = 0; i < item.child.length; i++) {
              if (item.child[i].select == 1) {
                radioGroupSelectedVal = item.child[i].id;
                break;
              }
            }
          }

          let radioGroup;
          if (radioGroupSelectedVal && radioGroupSelectedVal > 0) {
            radioGroup = radioGroupSelectedVal;
          } else {
            radioGroup = "";
          }

          this.$set(this.$data, this.inputTypeId[item.id].keyValuePair, {
            ...item,
            radioGroup,
            checkbox: [],
          });
        }

        if (item.select == 1) {
          this.changeServiceSelect(1, item);
        }
      });
      this.demandServiceList.wcfw.forEach((item, index) => {
        if (item.select == 1) {
          item.select = 0;
        }
        item.child.forEach((key, i) => {
          if (key.select == 1) {
            key.select = 0;
            key.dw_num = 1;
          }
        });

        let radioGroupSelectedVal;
        if (this.inputTypeId[item.id]) {
          if (this.radioGroupSpecialintroduce.indexOf(item.id) != -1) {
            for (let i = 0; i < item.child.length; i++) {
              if (item.child[i].select == 1) {
                radioGroupSelectedVal = item.child[i].id;
                break;
              }
            }
          }

          let radioGroup;
          if (radioGroupSelectedVal && radioGroupSelectedVal > 0) {
            radioGroup = radioGroupSelectedVal;
          } else {
            radioGroup = "";
          }

          this.$set(this.$data, this.inputTypeId[item.id].keyValuePair, {
            ...item,
            radioGroup,
            checkbox: [],
          });
        }

        if (item.select == 1) {
          this.changeServiceSelect(1, item);
        }
      });

      // 预算价格
      this.estimatedAmount = {};
    },
    // 添加 附件
    handleChangeLoad(val, valList) {
      /**
       * 单文件上传
       */
      // 后缀名
      let lastSuffix = this.getSuffix(val.name);
      let allow = true;
      val.progress = 0;
      val.upping = false;

      if (this.suffix_text.indexOf(val.name.getSuffix()) == -1) {
        allow = false;
        this.$message.error(`不支持上传${val.name.getSuffix()}格式的文件`);
        return;
      }

      if (
        this.fileList.find((item) => {
          return item.name == val.name;
        })
      ) {
        this.$message.error(`已有同名文件`);
        allow = false;
        return;
      }

      // 文件大于1G 不让上传
      if (val.size > 1024 ** 3) {
        allow = false;
        this.$message.error(`单个文件过大，请分多成多个文件上传`);
        return;
      }

      if (allow) {
        this.fileList.push(val);
      } else {
        this.$message.error(`不支持上传${lastSuffix}格式的文件`);
      }

      //////////////////
      /**
       * 多文件选择
       */
      // let addList = [];
      // let prohibitList = [];
      // valList.forEach((item, index) => {
      //   let lastSuffix = this.getSuffix(item.name);
      //   let allow = false;
      //   this.integratedSuffix.forEach((key, i) => {
      //     if (key.indexOf(lastSuffix) != -1) {
      //       item.imgIndex = i;
      //       addList.push(item);
      //       allow = true;
      //     }
      //   });
      //   if (!allow) {
      //     valList.splice(index, 1);
      //     prohibitList.push(lastSuffix);
      //   }
      // });
      // if (prohibitList.length > 0) {
      //   this.$message.error(`不支持上传${prohibitList.join(",")}格式的文件`);
      // }
      // this.fileList = addList;
      // console.log(this.fileList);
    },
    // 获取 后缀名
    getSuffix(name) {
      return name.substring(name.lastIndexOf("."));
    },
    // 删除已添加的附件
    removeAppendix(indexs) {
      this.fileList.splice(indexs, 1);
    },
    uploadImage() {
      let imgGroupStr = [];
      let imgGroupFile = [];
      const loading = this.$loading({
        lock: true,
        // text: "有文件正在上传不可“保存草稿箱”与“确认下单”",
        text: "正在提交设计订单和设计图纸请耐心等待....",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      try {
        this.fileList.forEach((item, index) => {
          if (typeof item.raw == "object") {
            item.iw = index;
            imgGroupFile.push(item);
          } else {
            imgGroupStr.push(item);
            item.upping = false;
            item.progress = 100;
          }
        });
      } catch (error) {
        loading.close();
        this.$message({
          message: `上传的文件数据有误,请重新提交`,
          type: "error",
          callback: (action) => {},
        });
      }

      try {
        return new Promise((resolve, reject) => {
          Promise.all(
            imgGroupFile.map((item, index) => {
              return this.uploadOnlySplit(
                item.raw,
                1024 * 1024 * 10,
                item.iw,
                (ing, i, total) => {
                  let complete = parseInt((i / total) * 100);
                  this.fileList[item.iw].upping = true;
                  this.fileList[item.iw].progress = complete;
                  this.$forceUpdate();
                }
              );

              // if (item.size > 1024 ** 2 * 20) {
              //   // 分片上传

              // } else {
              //   // 一般大文件上传
              //   return this.uploadSmallFile(item.raw, item.iw, (ing) => {
              //     let complete = parseInt((ing.loaded / ing.total) * 100);
              //     this.fileList[item.iw].upping = true;
              //     this.fileList[item.iw].progress = complete;
              //     this.$forceUpdate();
              //     // console.log(item.name, complete);
              //   });
              // }
            })
          )
            .then((res) => {
              let result = [];
              res.forEach((item, index) => {
                if (item.data && item.code == 200) {
                  result.push({
                    name: imgGroupFile[index].name,
                    size: imgGroupFile[index].size,
                    url: item.data.url,
                    temporary_url: item.data.temporary_url,
                  });
                } else {
                  this.$message({
                    message: `${imgGroupFile[index].name}上传异常`,
                    type: "error",
                    callback: (action) => {},
                  });
                }
              });
              imgGroupStr.push(...result);
              // console.log(imgGroupStr);
              loading.close();
              resolve(imgGroupStr);
            })
            .catch((err) => {
              loading.close();
              // console.log(err, "imgGroupStr");
              reject(err);
            });
        });
      } catch (error) {
        loading.close();
        this.$message({
          message: `上传的文件数据有误,请重新提交`,
          type: "error",
          callback: (action) => {},
        });
      }
    },

    // 是否 显示 提示 ‘请选择需求数量’
    repetFilter(type, id) {
      let { un_showNeedTodoList, serveForm_id } = this.$data;
      if (type) {
        // 无填写设置 服务 增加对应
        if (un_showNeedTodoList.indexOf(id) != -1) {
          this.un_showNeedTodo.push(id);
        }
      } else {
        let fill_num = this.un_showNeedTodo.indexOf(id);
        if (fill_num != -1) {
          this.un_showNeedTodo.splice(fill_num, 1);
        }
      }

      // let filterList = [];
      // if (serveForm_id.length > 0) {
      //   serveForm_id.forEach((item) => {
      //     let result = un_showNeedTodoList.filter((val) => {
      //       return val == item;
      //     });
      //     filterList.push(...result);
      //   });

      //   if (serveForm_id.length > filterList.length) {
      //     this.un_showNeedTodo = true;
      //   } else {
      //     this.un_showNeedTodo = false;
      //   }
      // } else {
      //   this.un_showNeedTodo = false;
      // }
    },

    // 大文件上传
    async uploadOnlySplit(file, sliceLength = 1024 * 1024 * 10, turn, uploadCallback) {
      //大小分界值
      let cutoff_value = 1024 * 1024 * 20;

      if (file.size <= cutoff_value) {
        sliceLength = file.size;
      }

      // 请求标识符
      let uploadOn = await $uploadOnlySplitOn({
        file_name: file.name,
        size: file.size, // 文件总大小
        suffix: file.name.getSuffix(),
      });
      // 使用进一法，来确定分片的个数
      let total_number = Math.ceil(file.size / sliceLength);
      // 分片的初始位置
      let start = 0;
      // 分片的结束位置
      let end = sliceLength;
      // 这里为promise.all方法准备一个数组
      let requset_file = null;

      for (let i = 1; i <= total_number; i++) {
        // 这里开始分片，并且把每一个分片上传到服务器
        // File{}
        //[0,0,1,0,1,2,3,4,5,5,2]
        let blob = file.slice(start, end); // 得到一个分片
        let formData = await new FormData(); // 创建一个FormData对象，准备传送数据
        await formData.append("file", blob); // formData
        await formData.append("uploadId", uploadOn.data.uploadId); // 同时为这个分片设置一个名称，其中的i帮助后端进行排序处理
        // formData组装好之后，调用pro()函数，返回一个promise对象，并把它放入parr数组中，方便后面的promise.all方法使用
        await formData.append("OSS_SEEK_TO", start);
        await formData.append("OSS_LENGTH", end);
        await formData.append("batch", i);
        if (i == total_number) {
          await formData.append("isuploadEnd", true);
        }
        start = end; // 调整下一个分片的起始位置
        end = start + sliceLength; // 调整下一个分片的结束位置
        if (end > file.size) {
          end = file.size; // 这里对最后的一个分片结束位置进行调整
        }

        // 打印 上传 formData数据
        // for (var value of formData.values()) {
        //   console.log(value);
        // }
        try {
          // 处理 并发问题 以及 传输顺序
          let result = await $uploadOnlySplitUpload({
            formData,
            onUploadProgress: (progressEvent) => {},
          });
          uploadCallback(null, i, total_number);
          result.dev_name = file.name;
          if (typeof result == "object" && i == total_number && result.code == 200) {
            requset_file = result;
          }
        } catch (error) {}
      }
      return new Promise((resolve, reject) => {
        resolve(requset_file);
      });
    },

    // 一般文件上传
    uploadSmallFile(file, turn, uploadCallback) {
      let param = new FormData();
      param.append("file", file);
      return new Promise((resolve, reject) => {
        $uploadUploadLarge({
          formData: param,
          onUploadProgress: (progressEvent) => {
            uploadCallback(progressEvent);

            // // console.log("progressEvent", progressEvent);
            // let complete = parseInt(
            //   (progressEvent.loaded / progressEvent.total) * 100
            // );
            // this.fileList[item.iw].upping = true;
            // this.fileList[item.iw].progress = complete;
            // this.$forceUpdate();
          },
        })
          .then((res) => {
            res.dev_name = file.name;
            resolve(res);
          })
          .catch((err) => {
            err.dev_name = file.name;
            reject(err);
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// .mask-blackshadow {
//   position: relative;
//   z-index: 50;
//   box-shadow: 0px 0px 0px 999999px rgba(0, 0, 0, 0.7);
// }

::v-deep .form-input {
  textarea {
    width: calc(var(--proportion) * 600px);
    max-height: 80px !important;
  }
}
::v-deep .el-form-item__error {
  position: unset;
}
.wrap-contianer {
  position: relative;
  box-sizing: border-box;
  display: inline-block;
  min-width: 1100px;
  width: 100%;
  min-height: 100vh;

  ::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: #e60000;
    background: #e60000;
  }

  ::v-deep .el-radio__input.is-checked + .el-radio__label {
    color: #e60000;
  }

  .backdrop {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 0;
    width: 100%;

    img {
      width: 100%;
      // height: 100%;
      object-fit: cover;
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0px;
      width: 100%;
      height: 120px;
      background: linear-gradient(0deg, RGBA(16, 15, 15, 1), transparent);
    }
  }

  .content-wrap {
    position: relative;
    z-index: 10;
    margin-top: 64px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    // height: 100%;
    .left-process.dark {
      opacity: 0;
    }
    .left-process {
      margin-right: calc(var(--proportion) * 233px);
      flex-shrink: 1;
      min-width: calc(0.67 * 188px);
      min-height: calc(0.67 * 553px);
      width: calc(var(--proportion) * 188px);
      height: calc(var(--proportion) * 553px);

      // border: 1px solid #000;

      img {
        width: 100%;
        height: 100%;
      }
    }
    .screen-two,
    .screen-one {
      padding: 0px 40px;
    }
    .screen-page {
      width: 100%;
      height: 10px;
      background: #f5f5f5;
    }
    .right-form {
      position: relative;
      top: -64px;
      box-sizing: border-box;
      padding-top: 64px;
      min-width: 900px;
      width: calc(var(--proportion) * 1100px);
      // height: 100vh;
      // overflow-y: scroll;
      // overflow-x: visible;
      .form-whiteboard {
        box-sizing: border-box;
        padding: 30px 0px;
        padding-top: 48px;
        min-height: 963px;
        background-color: #fff;
      }
      .right-form-title {
        position: relative;
        padding: 0px 40px;
        font-size: 20px;

        font-weight: bold;
        color: #333333;

        .clear-todo {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 40px;
          font-size: 14px;

          font-weight: 400;
          color: #e60000;
          cursor: pointer;
          img {
            width: 14px;
            height: 14px;
          }
        }
      }

      .info-title {
        position: relative;
        margin: 30px 0px;
        margin-bottom: 16px;
        font-size: 18px;

        font-weight: bold;
        color: #333333;
        .check-details.pictrue {
          display: inline-block;
          position: relative;
          top: 0px;
          left: 0px;
          transform: none;
        }
        .check-details {
          cursor: pointer;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 0px;
          font-size: 14px;

          font-weight: 400;
          color: #3094e0;
        }
      }
      .form-input.notline {
        padding-right: 0px;
      }
      .form-input.address {
        // height: 72px;
      }
      .form-select,
      .form-input {
        position: relative;
        box-sizing: border-box;
        width: calc(var(--proportion) * 353px);
      }

      .textarea-form {
        width: calc(var(--proportion) * 850px);
        max-width: 815px;
        min-width: 500px;
      }
      .adjacent-select {
        width: calc((var(--proportion) * (353px / 2)) - 5px);
      }
      .form-label.not {
        margin-right: 0px;
      }
      .form-label.right-margin {
        margin-right: calc(var(--proportion) * 17px);
      }
      .form-label {
        margin-right: calc(var(--proportion) * 18px);
      }
      .form-label {
        margin-bottom: 16px;
      }

      ::v-deep .el-form-item__label::before {
        content: "";
        margin-right: 0px;
      }
      ::v-deep
        .el-form-item.is-required:not(.is-no-asterisk)
        > .el-form-item__label:after {
        content: "*";
        position: absolute;
        right: 7px;
        top: 50%;
        transform: translateY(-50%);
        color: #f56c6c;
      }
      ::v-deep .el-form-item__label {
        position: relative;
        padding-right: 24px;
        // margin-top: -10px;
      }
    }
    //兼容火狐
    .right-form {
      scrollbar-width: none;
    }
    .right-form::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 0px;
      /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }

    .right-form::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
      background: #e60000;
      cursor: pointer;
    }

    .right-form::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
      border-radius: 10px;
      background: rgba(255, 255, 255, 0.1);
    }
  }
}
.screen-two {
  .peripherals {
    .checkbox-input-group {
      // justify-content: space-around !important;
    }
  }
  .form-title-screen-two {
    margin-bottom: 16px;
    font-size: 16px;

    font-weight: bold;
    color: #666666;
  }

  .form-screen-main {
    ::v-deep .el-checkbox {
      margin-right: 6px;
      .el-checkbox__label {
        color: #606266;
        padding-left: 6px;
      }
    }
    .checkbox-input-group {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: flex-start;

      ::v-deep .el-radio {
        margin-right: 10px;
      }
    }
    .checkbox-input.bottom {
      margin-bottom: 20px;
    }
    .checkbox-input.not-margin {
      margin-bottom: 0px;

      ::v-deep .el-form-item__content {
        display: flex;
        align-items: center;
        height: 40px;
      }
    }
    .checkbox-input {
      margin-bottom: 10px;
      margin-right: 12px;
      display: flex;
      align-items: center;
      min-width: 230px;
    }
    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
    ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #e60000;
      border-color: #e60000;
    }
  }

  .screen-two-form-lalbel {
    ::v-deep .el-form-item__content {
      line-height: 36px;
    }
    ::v-deep .el-checkbox {
      .el-checkbox__label {
        color: #606266;
        padding-left: 6px;
      }
    }

    ::v-deep .el-form-item__content .el-checkbox-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    ::v-deep .el-form-item__content {
      margin-left: 75px;
      // width: 700px;
    }
    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
    ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #e60000;
      border-color: #e60000;
    }
  }
}

.renderings-input {
  position: relative;
  width: 120px;
  .suffix-input {
    position: absolute;
    top: 50%;
    right: 6px;
    transform: translateY(-50%);
  }
}
.screen-two-form-lalbel {
  ::v-deep .el-form-item__label {
    font-size: 16px !important;

    font-weight: bold;
    color: #666666;
  }
}

.screen-three {
  padding: 24px 40px;

  .content-order {
    width: 100%;
    display: flex;
    justify-content: flex-start;

    .content-order-right,
    .content-order-left {
      width: 50%;

      .todo-img {
        margin-bottom: 10px;
        font-size: 14px;
        width: 90%;
        font-weight: 400;
        color: #999999;
      }

      .name-img {
        width: 170px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;

        font-weight: 400;
        color: #333333;
      }
      .img-delete {
        cursor: pointer;
        position: absolute;
        top: 1px;
        right: 6px;
        font-size: 14px;

        font-weight: 400;
        color: #e60000;
        display: none;
      }
      .img-byte {
        margin-top: 6px;
        font-size: 14px;

        font-weight: 400;
        color: #999999;
      }
      .show-img-list {
        position: relative;
        display: inline-block;
        box-sizing: border-box;
        width: 200px;
        .show-item-img:hover {
          .img-delete {
            display: inline-block;
          }
        }
        .show-item-img {
          position: relative;
          margin: 8px 0px;

          .img-loading {
            display: flex;
            align-items: center;
            font-size: 14px;

            font-weight: 400;
            color: #999999;
            .loading-width {
              margin-right: 6px;
              width: 100px;
            }
          }
        }
      }
    }
  }
}
.table-order {
  ::v-deep .el-table th.el-table__cell > .cell {
    padding: 0px 24px;
  }
  ::v-deep .el-table .cell {
    padding: 0px 24px;
  }
  ::v-deep .has-gutter tr th {
    font-size: 16px;

    font-weight: bold;
    color: #333333;
    background-color: #f5f5f5 !important;
  }

  .price-scope {
    font-size: 14px;

    font-weight: bold;
    color: #f39910;
  }
  .order-right-total {
    box-sizing: border-box;
    padding: 0px 24px;
    width: 100%;
    height: 40px;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: right;

    .vip-discount {
      margin-right: 28px;
      font-size: 16px;

      font-weight: 400;
      color: #333333;
    }
    .total-price {
      font-size: 16px;

      font-weight: bold;
      color: #e60000;
      span {
        color: #333;
      }
    }
  }
}

.upload-demo {
  .download-icon-hover {
    display: none;
  }

  button:hover {
    background-color: #e60000 !important;
    color: #fff;

    .download-icon {
      display: none;
    }
    .download-icon-hover {
      display: inline-block;
    }
  }
}

.download-icon-hover,
.download-icon {
  position: relative;
  top: -1px;
  width: 14px;
  height: 14px;
}
.fixed-change-details {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 99;
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  min-width: 1100px;
  height: 100%;
  .fixed-change-details-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(var(--proportion));
    width: 755px;
    min-height: 450px;
    background-color: #fff;
    .title {
      position: relative;
      padding: 0px 25px;
      width: 100%;
      height: 56px;
      display: flex;
      align-items: center;
      font-size: 24px;

      font-weight: bold;
      color: #333333;
      box-shadow: 0px 1px 0px 0px #eeeeee;
      .fixed-change-details-close {
        cursor: pointer;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 25px;
        width: 16px;
        height: 16px;
      }
    }
  }
}
.fixed-change-details-table {
  box-sizing: border-box;
  padding: 24px;
  width: 100%;
  ::v-deep .el-table th.el-table__cell.is-leaf {
    background: #e5e5e5;
  }
  ::v-deep .el-table td.el-table__cell {
    background: #f5f5f5;
  }
}
.submit-btn {
  margin-top: 65px;
  .submit-btn-save {
    margin-right: 16px;
    width: 160px;
    background: #f39910;
    color: #fff;
  }
  .submit-btn-place {
    width: 160px;
    background: #e60000;
    color: #fff;
  }
}
.material-content {
  position: relative;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0px 40px;
  // overflow-x: scroll;
  // overflow-y: visible;
  width: 100%;
}
.material-item {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100%;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 522px;
  img.hover {
    transform: scale(1.2);
  }

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
}
.toast-material {
  color: #fff;
  font-size: 0.48rem;
  background: rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  padding: 0px 30px;
  height: 50px;
  line-height: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.swiper-index-img-item.active {
  border: 3px solid #e60000;
}
.swiper-index-img-item {
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 108px;
  cursor: pointer;
  border: 3px solid #ddd;
  img.hover {
    transform: scale(1.2);
  }

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
}
.swiper-index-img {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 40px;
}

.swiper-button-prev {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -10px;
  background-image: url(../assets/icon/zjt2_img.png);
}
.swiper-button-prev:hover,
.swiper-button-next:hover {
  opacity: 1;
}
.swiper-button-prev,
.swiper-button-next {
  opacity: 0.6;
}
.swiper-button-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -10px;
  background-image: url(../assets/icon/yjt1_img.png);
}
// .img-item-button-prev {
// }
.form-checkbox {
  min-width: 212px;
}
.radio-only {
  min-width: 212px;
}
.date-picker-shelf {
  box-sizing: border-box;
  width: calc(var(--proportion) * 353px);
}
::v-deep .el-button--danger.is-plain:hover {
  background-color: #e632410e;
}
::v-deep .el-button--danger.is-plain {
  border: 1px solid #e60000;
  color: #e60000;
  background-color: #fff;
}
::v-deep .el-form--inline .el-form-item__label {
  float: left !important;
}
// 大字标题
.headline {
  padding-top: calc(var(--proportion) * 148px);
  margin-bottom: calc(var(--proportion) * 48px) !important;
  // font-size: calc(var(--proportion) * 52px) !important;
  font-size: 28px !important;
  font-weight: 800;
}
// 小字副标题
.small_caption {
  opacity: 0.7 !important;
  margin-bottom: calc(var(--proportion) * 92px) !important;
  font-weight: "PingFang SC", Helvetica, "Microsoft YaHei";
  font-size: calc(var(--proportion) * 16px) !important;
  font-weight: 100 !important;
  line-height: 1 !important;
}
.mar-bottom {
  margin-bottom: calc(var(--proportion) * 48px) !important;
}
// .custom-form-label.right-margin {
//   margin-right: calc(var(--proportion) * 15px) !important;
// }
.custom-form-label {
  max-width: 445px;
  // width: calc(var(--proportion) * 470px);
  min-width: 292px;
}
.wrap-contianer .content-wrap .right-form .adjacent-select.custom-select-width-mini {
  width: calc(var(--proportion) * 100px);
}
.wrap-contianer .content-wrap .right-form .adjacent-select.custom-select-width-madd {
  width: calc(var(--proportion) * 242px);
}
</style>
